import type { Dict } from "../lib/i18n";

// Keys are prefixed "nutrition." — keep zh / en / nl in step.
export default {
  zh: {
    "nutrition.pantry.ask": "食材库里有“{name}”。这是从家里拿的吗？",
    "nutrition.pantry.take": "从食材库减去",
    "nutrition.pantry.taken": "“{name}”库存减少了 {qty}。",
    "nutrition.pantry.takenEst": "“{name}”库存减少了约 {qty}（没有包装重量，按常见分量算；可在食材库核对）。",
    "nutrition.hub.todayList": "今天吃了什么",
    "nutrition.labelTips.title": "拍清楚营养成分表，照片会和这件食品一起存档：",
    "nutrition.labelTips.straight": "正对着表格拍，不要斜着拍",
    "nutrition.labelTips.sharp": "对好焦，字要看得清，避开反光",
    "nutrition.labelTips.whole": "整张表都在画面里，包括“每 100 克”那一行",
    "nutrition.pack.name": "食品名称",
    "nutrition.pack.namePh": "例如：全麦饼干",
    "nutrition.pack.storeTitle": "买回来的？放进食材库",
    "nutrition.pack.storeHint": "营养数据和这张照片一起存进食材库；填了价格，也会记进家庭账本。",
    "nutrition.pack.price": "价格（可不填）",
    "nutrition.pack.storeBtn": "放进食材库",
    "nutrition.pack.needName": "先写上食品名称。",
    "nutrition.pack.stored": "已放进食材库，营养数据和照片都存好了。",
    "nutrition.pack.storedPaid": "已放进食材库，价格也记进了家庭账本。",
    "nutrition.pack.storedShort": "已放进食材库",
    "nutrition.ex.workout": "记一次运动",
    "nutrition.hub.exerciseSub": "记步数、健身、跑步，算出消耗",
    "nutrition.balance.eaten": "吃进",
    "nutrition.balance.burned": "消耗",
    "nutrition.balance.diff": "差额",
    "nutrition.snap.tip1": "拍正：手机放在盘子正上方，从上往下拍。",
    "nutrition.snap.tip2": "拍全：整顿饭都要在画面里，有几个盘子、碗就一起拍进去。",
    "nutrition.snap.tip3": "拍亮：光线充足、对好焦，估算才准。",
    "nutrition.balance.status": "今天的健康状态：",
    "nutrition.balance.statusGood": "很好 👍",
    "nutrition.balance.statusKcal": "热量超出 {v} 千卡",
    "nutrition.balance.statusSugar": "糖吃多了",
    "nutrition.balance.statusSalt": "盐吃多了",
    "nutrition.balance.statusNone": "还没有记录今天吃了什么",
    "nutrition.hub.steps": "步数",
    "nutrition.hub.stepsSub": "记今天走了多少步，换算成卡路里",
    "nutrition.hub.stepsToday": "今天 {n} 步",
    "nutrition.balance.title": "今天的能量平衡",
    "nutrition.balance.setup": "填一次身高、体重、年龄和平时的活动量，App 就能算出你每天消耗多少卡路里，和吃进的对比。",
    "nutrition.balance.setupBtn": "填身体资料",
    "nutrition.balance.open": "打开今天的能量平衡",
    "nutrition.balance.sum": "吃进 {eaten} − 消耗 {burned} = {diff} 千卡",
    "nutrition.balance.deficit": "比消耗少吃 {v} 千卡，体重会往下走。",
    "nutrition.balance.surplus": "比消耗多吃 {v} 千卡，多出的会存成脂肪。",
    "nutrition.balance.even": "吃进和消耗差不多，体重会保持。今天的标准还可以吃 {left} 千卡。",
    "nutrition.balance.parts": "消耗包括：{parts}",
    "nutrition.balance.partBase": "基础和日常 {v}",
    "nutrition.balance.partPhone": "手机记录的活动 {v}",
    "nutrition.balance.partSteps": "走路 {steps} 步 ≈ {v}",
    "nutrition.balance.partExercise": "运动 {v}",
    "nutrition.balance.stepsToday": "今天 {n} 步 · 修改",
    "nutrition.balance.addSteps": "加今天的步数和活动",
    "nutrition.balance.how": "看计算过程",
    "nutrition.balance.soFar": "今天还没结束：按你的标准，今天还可以吃 {left} 千卡。晚饭后看结果最准。",
    "nutrition.scan.noNumbers": "找到了这个商品，但公开的食品数据库里还没有它的营养数据。拍一下包装上的营养成分表，App 会在手机上读出来（免费）。读出来后会记住，以后谁扫这个条形码都能直接看到。",
    "nutrition.scan.labelPhoto": "营养成分表的照片",
    "nutrition.scan.labelFail": "没读清楚。请把营养表拍正、拍清楚一点再试；也可以手动填写。",
    "nutrition.scan.typeIt": "手动填写",
    "nutrition.scan.fromLabel": "营养数据来自包装照片",
    "nutrition.ex.kcalShort": "消耗 {n} 千卡",
    "nutrition.ex.todayList": "今天已记",
    "nutrition.ex.basisDefault": "还没记体重，先按 {kg} 公斤估算；记了体重会更准。",
    "nutrition.ex.basis": "按你最近的体重 {kg} 公斤估算，中等强度。",
    "nutrition.ex.save": "记下：消耗 {kcal} 千卡",
    "nutrition.ex.estimated": "按你的体重自动估算，可以改",
    "nutrition.ex.kcal": "消耗（千卡）",
    "nutrition.ex.min": "{n} 分钟",
    "nutrition.ex.minutes": "多少分钟",
    "nutrition.ex.other": "其他",
    "nutrition.ex.dance": "跳舞",
    "nutrition.ex.chores": "家务园艺",
    "nutrition.ex.yoga": "瑜伽",
    "nutrition.ex.gym": "健身",
    "nutrition.ex.swim": "游泳",
    "nutrition.ex.run": "跑步",
    "nutrition.ex.cycle": "骑车",
    "nutrition.ex.walk": "散步",
    "nutrition.ex.kind": "运动类型",
    "nutrition.ex.title": "记一次运动",
    "nutrition.ach.exercise": "运动了 {days} 天，共消耗 {kcal} 千卡，真棒！",
    "nutrition.month.exerciseDays": "运动 {n} 天",
    "nutrition.month.exercise": "运动消耗",
    "nutrition.hub.burnedLine": "运动消耗 {burned} 千卡 · 净摄入 {net} 千卡",
    "nutrition.hub.exerciseToday": "今天消耗 {kcal} 千卡",
    "nutrition.hub.exercise": "运动",
    "nutrition.hub.photoNone": "今天已用完",
    "nutrition.hub.photoLeft": "今天还能拍 {n} 次",
    "nutrition.pack.checkNumbers": "这些数字是手机从照片上读出来的，请和包装核对一下。",
    "nutrition.pack.useAi": "✨ 用 AI 读取（剩 {n} 次）",
    "nutrition.pack.unreadable": "没能读清这张营养成分表。可以拍正、拍亮一点再试，或者换别的方式：",
    "nutrition.pack.readingPhone": "正在识别营养成分表… {pct}%",
    "nutrition.pack.free": "在手机上识别，免费，不用 AI 次数。",
    "nutrition.pack.toPantry": "买回来的商品想存进食材库？点这里放进食材库",
    "nutrition.pack.howMuchMl": "你喝多少毫升？",
    "nutrition.pack.howMuch": "你吃多少克？",
    "nutrition.pack.level.high": "高",
    "nutrition.pack.level.medium": "中",
    "nutrition.pack.level.low": "低",
    "nutrition.pack.perPortion": "每份",
    "nutrition.pack.per100ml": "每 100 毫升",
    "nutrition.pack.per100g": "每 100 克",
    "nutrition.pack.table": "营养成分",
    "nutrition.pack.product": "包装食品",
    "nutrition.pack.reading": "正在读取营养成分…",
    "nutrition.pack.intro": "拍下包装上的营养成分表（Voedingswaarde / Nutrition facts），拍正、拍清楚。手机会读出每 100 克的热量、碳水、糖、脂肪、蛋白质和盐，并标出高低。",
    "nutrition.pack.title": "拍包装食品",
    "nutrition.hub.goalsSet": "设置每日目标",
    "nutrition.hub.packSub": "拍营养成分表或条形码，记下吃了多少（免费）",
    "nutrition.hub.pack": "拍包装食品",
    "nutrition.hub.photo": "拍这一餐",
    "nutrition.hub.photoSub": "估算卡路里和碳水",
    "nutrition.hub.scan": "扫条形码",
    "nutrition.hub.scanSub": "查营养数据库",
    "nutrition.hub.cook": "做一道菜",
    "nutrition.hub.cookSub": "用食材库的食材做饭，精确算出每份营养",
    "nutrition.hub.manual": "手动记",
    "nutrition.hub.manualSub": "自己输入吃了什么、多少卡路里",
    "nutrition.hub.drink": "记饮料",
    "nutrition.hub.drinkSub": "记每杯饮料的卡路里和糖",
    "nutrition.hub.drinkToday": "今天 {n} 杯",
    "nutrition.hub.weight": "体重",
    "nutrition.hub.weightSub": "记体重，看每周的变化",
    "nutrition.hub.fasting": "轻断食",
    "nutrition.hub.fastingSub": "设定进食时间，自动计时提醒",
    "nutrition.hub.fastingNow": "已断食 {h}:{m}",
    "nutrition.hub.day": "今天吃了什么",
    "nutrition.hub.dayCount": "{n} 条记录",
    "nutrition.hub.dayNone": "还没有记录",
    "nutrition.hub.month": "本月总结",
    "nutrition.hub.monthSub": "一个月的饮食报告，可导出 Excel",
    "nutrition.hub.goals": "我的目标",
    "nutrition.hub.goalsKcal": "每天 ≤ {kcal} 千卡",
    "nutrition.hub.goalsNone": "还没设置",
    "nutrition.hub.today": "今天",
    "nutrition.hub.todayOpen": "点这里看明细 ›",
    "nutrition.impact.biggest": "要注意的是{name}：占一天的 {pct}%",
    "nutrition.photo.button": "拍这一餐",
    "nutrition.photo.buttonSub": "拍一盘菜，AI 估算",
    "nutrition.scan.buttonBig": "扫条形码",
    "nutrition.scan.buttonSub": "包装食品和饮料",
    "nutrition.hero.logManual": "手动记",
    "nutrition.photo.title": "拍这一餐",
    "nutrition.photo.intro": "把整盘饭菜拍进画面，光线亮一点。AI 会估算这一份的热量、糖、脂肪和盐。",
    "nutrition.photo.reading": "正在估算这一餐…",
    "nutrition.photo.readingTime": "通常 5–15 秒。",
    "nutrition.photo.grams": "估计约 {g} 克",
    "nutrition.photo.again": "重拍",
    "nutrition.photo.meal": "这一餐",
    "nutrition.photo.estimateNote": "照片估算会有误差，可以在下一步修改。包装食品用“扫条形码”更准确。",
    "nutrition.impact.title": "这一餐占你一天的多少",
    "nutrition.impact.kcalLine": "{kcal} 千卡，占一天的 {pct}%",
    "nutrition.impact.noKcal": "热量未知",
    "nutrition.impact.overToday": "吃完这一餐，今天的{list}会超过目标。可以少吃一点，或者下一餐清淡些。",
    "nutrition.impact.overDay": "加上这一餐，这一天的{list}会超过目标。",
    "nutrition.impact.leftToday": "吃完这一餐，今天还可以吃 {kcal} 千卡。",
    "nutrition.impact.leftDay": "加上这一餐，这一天还剩 {kcal} 千卡。",
    "nutrition.impact.name.kcal": "热量",
    "nutrition.impact.name.sugar": "糖",
    "nutrition.impact.name.fat": "脂肪",
    "nutrition.impact.name.salt": "盐",
    "nutrition.impact.name.carbs": "碳水",
    "nutrition.impact.name.protein": "蛋白质",
    "nutrition.impact.limitLeft": "每天 {daily} {unit}，还剩 {n} {unit}",
    "nutrition.impact.overBy": "超出 {n} {unit}",
    "nutrition.impact.needLeft": "今天还需要 {n} {unit}",
    "nutrition.impact.needMet": "今天的需要已经够了",
    "nutrition.impact.unknown": "没有这项数据",
    "nutrition.impact.basisGoal": "按你在“我的目标”里设的每日量计算；没设的项目按欧盟包装上的成人每日参考摄入量。浅色是今天已经吃的，深色是这一餐。",
    "nutrition.impact.basisRi": "按成人每日参考摄入量计算（和欧盟食品包装上的百分比一致）：热量 2000 千卡、脂肪 70 克、糖 90 克、盐 6 克。浅色是今天已经吃的，深色是这一餐。可以在“我的目标”里设成你自己的。",
    "nutrition.month.title": "本月总结",
    "nutrition.month.prev": "上个月",
    "nutrition.month.next": "下个月",
    "nutrition.month.noWeight": "还没有记录体重。记下今天的体重，作为这个月的起点吧！",
    "nutrition.month.startedOn": "起点：{date}",
    "nutrition.month.logWeight": "记体重",
    "nutrition.month.weightKg": "体重（公斤）",
    "nutrition.month.weightHint": "建议每次在同一时间称，比如早上起床后、早饭前。",
    "nutrition.month.weightSaved": "体重已记下",
    "nutrition.body.title": "我的体重",
    "nutrition.body.kg": "公斤",
    "nutrition.body.today": "今天",
    "nutrition.body.lastOn": "上次称：{date}",
    "nutrition.body.waistShort": "腰围 {cm} 厘米",
    "nutrition.body.none": "还没有记录体重。每天早上称一次，就能看到饮食控制带来的变化。",
    "nutrition.body.sinceMonth": "本月变化",
    "nutrition.body.logToday": "记今天的体重",
    "nutrition.body.editToday": "修改今天的体重",
    "nutrition.body.bmi.under": "偏瘦",
    "nutrition.body.bmi.normal": "正常",
    "nutrition.body.bmi.over": "超重",
    "nutrition.body.bmi.obese": "肥胖",
    "nutrition.body.standard": "标准体重",
    "nutrition.body.above": "比标准多 {kg} 公斤",
    "nutrition.body.below": "比标准少 {kg} 公斤",
    "nutrition.body.healthy": "健康范围",
    "nutrition.body.askHeight": "填一下身高，就能算出你的 BMI 和标准体重。",
    "nutrition.body.setHeight": "填身高",
    "nutrition.body.heightShort": "身高 {cm}",
    "nutrition.body.height": "身高（厘米）",
    "nutrition.body.heightHint": "只需填一次，用来算 BMI 和标准体重",
    "nutrition.body.waist": "腰围（厘米）",
    "nutrition.body.optional": "可不填",
    "nutrition.body.formula": "标准体重 = 身高（厘米）− 105。健康体重范围按 BMI 18.5–24.9 计算。",
    "nutrition.month.days": "记录天数",
    "nutrition.month.avgKcal": "平均每天热量",
    "nutrition.month.avgSugar": "平均每天糖",
    "nutrition.month.drinkSugar": "饮料里的糖",
    "nutrition.month.drinks": "{n} 杯 · {kcal} 千卡",
    "nutrition.month.fasts": "断食达标",
    "nutrition.month.longest": "最长 {h} 小时",
    "nutrition.month.sugarDays": "控糖达标天数",
    "nutrition.month.sugarMax": "每天 ≤ {g} 克",
    "nutrition.month.empty": "这个月还没有记录。记下第一餐，就开始积累你的成就啦！",
    "nutrition.month.export": "导出本月 Excel 表格",
    "nutrition.month.exportHint": "包含月度总览（含图表）、每日明细、体重与身体、饮料和轻断食五张表。",
    "nutrition.ach.logged_days": "记录了 {days} 天饮食",
    "nutrition.ach.logging_streak": "连续记录 {days} 天，真有毅力！",
    "nutrition.ach.sugar_days": "{days} 天糖摄入在目标内",
    "nutrition.ach.fasts_done": "完成 {count} 次轻断食",
    "nutrition.ach.longest_fast": "最长一次断食 {hours} 小时",
    "nutrition.ach.weight_lost": "体重减少了 {kg} 公斤，太棒了！",
    "nutrition.ach.weight_steady": "体重保持稳定",
    "nutrition.badge.streak7": "坚持记录 7 天",
    "nutrition.badge.logged20": "记录 20 天",
    "nutrition.badge.sugar15": "控糖小能手",
    "nutrition.badge.fast10": "断食达人",
    "nutrition.badge.fast18h": "18 小时挑战",
    "nutrition.badge.lost1kg": "减重 1 公斤",
    "nutrition.meal.drink": "饮料",
    "nutrition.scan.tipMedium": "{list}含量中等，注意分量。",
    "nutrition.scan.tipPortionSugar": "这一份含糖约 {g} 克，相当于世卫组织建议每天游离糖理想上限（25 克）的 {pct}%。",
    "nutrition.scan.tipNutriScore": "Nutri-Score 为 {grade}，营养质量偏低，建议少吃，可以选同类里评分更好的。",
    "nutrition.scan.button": "扫一扫",
    "nutrition.scan.title": "扫描食品条形码",
    "nutrition.scan.hint": "把包装上的条形码放进取景框，会自动识别。",
    "nutrition.scan.slow": "扫不出来？试试：条形码横着放、离手机 15–20 厘米、避开反光；瓶子是弯的就转一转，让条形码正对镜头。也可以点下面“拍条形码照片”，或输入条形码下面的数字。",
    "nutrition.scan.starting": "正在打开摄像头…",
    "nutrition.scan.noCamera": "无法打开摄像头。可以拍一张条形码的照片，或者手动输入条形码下面的数字。",
    "nutrition.scan.photo": "拍条形码照片",
    "nutrition.scan.manual": "或手动输入条形码",
    "nutrition.scan.lookup": "查询",
    "nutrition.scan.looking": "正在查询营养数据…",
    "nutrition.scan.notFound": "数据库里还没有这件商品（{code}）。可以拍营养成分表，让 AI 帮你读。",
    "nutrition.scan.notFoundAction": "拍营养成分表",
    "nutrition.scan.noCode": "照片里没有找到条形码，请靠近一点、对好焦再拍。",
    "nutrition.scan.again": "再扫一个",
    "nutrition.scan.per100g": "每 100 克",
    "nutrition.scan.per100ml": "每 100 毫升",
    "nutrition.scan.amount": "我吃了多少（{unit}）",
    "nutrition.scan.serving": "一份：{label}",
    "nutrition.scan.forAmount": "{amount}{unit} 含有",
    "nutrition.scan.log": "记到饮食里",
    "nutrition.scan.source": "营养数据来自 Open Food Facts 开放数据库，可能有误差，请以包装为准。",
    "nutrition.scan.nutriScore": "Nutri-Score 营养评分",
    "nutrition.scan.kcal": "热量",
    "nutrition.scan.tipHigh": "{list}偏高。偶尔吃没关系，注意分量，搭配蔬菜更好。",
    "nutrition.scan.tipOk": "脂肪、糖和盐都不算高，是不错的选择。",
    "nutrition.scan.sep": "、",
    "nutrition.level.low": "低",
    "nutrition.level.medium": "中",
    "nutrition.level.high": "高",
    "nutrition.light.fat": "脂肪",
    "nutrition.light.saturatedFat": "饱和脂肪",
    "nutrition.light.sugar": "糖",
    "nutrition.light.salt": "盐",
    "nutrition.fast.title": "轻断食",
    "nutrition.fast.setup": "设置轻断食",
    "nutrition.fast.settings": "轻断食设置",
    "nutrition.fast.intro": "选一个方案，比如 16:8：每天在 8 小时内吃完，其余 16 小时只喝水、茶或黑咖啡。",
    "nutrition.fast.plan": "方案",
    "nutrition.fast.planDesc": "断食 {fast} 小时 · 进食 {eat} 小时",
    "nutrition.fast.eatStart": "每天几点开始吃",
    "nutrition.fast.window": "进食时间 {start}–{end}",
    "nutrition.fast.show": "在饮食页显示轻断食",
    "nutrition.fast.saved": "轻断食设置已保存",
    "nutrition.fast.status.fasting": "断食中",
    "nutrition.fast.status.reached": "已达成目标",
    "nutrition.fast.status.eating": "进食时间",
    "nutrition.fast.status.idle": "还没开始断食",
    "nutrition.fast.elapsed": "已断食 {h} 小时 {m} 分",
    "nutrition.fast.remaining": "还剩 {h} 小时 {m} 分",
    "nutrition.fast.closesIn": "进食窗口还剩 {h} 小时 {m} 分",
    "nutrition.fast.opensIn": "离进食时间还有 {h} 小时 {m} 分",
    "nutrition.fast.goal": "目标 {h} 小时",
    "nutrition.fast.start": "开始断食",
    "nutrition.fast.startEarlier": "我更早就开始了",
    "nutrition.fast.startTime": "开始时间",
    "nutrition.fast.end": "结束断食",
    "nutrition.fast.endEarly": "提前结束",
    "nutrition.fast.editStart": "改开始时间",
    "nutrition.fast.streak": "连续 {n} 天达标",
    "nutrition.fast.history": "最近的断食",
    "nutrition.fast.duration": "{h} 小时 {m} 分",
    "nutrition.fast.reachedShort": "达标",
    "nutrition.fast.short": "未达标",
    "nutrition.fast.delete": "删除",
    "nutrition.fast.ended": "断食结束，共 {h} 小时 {m} 分。",
    "nutrition.fast.endedReached": "太棒了！完成了 {h} 小时 {m} 分的断食。",
    "nutrition.fast.caution": "轻断食不适合孕期或哺乳期、糖尿病（尤其在用药的）、有饮食失调史的人以及未成年人。有健康问题请先咨询医生。断食期间多喝水，感到不适就停止。",
    "nutrition.title": "饮食",
    "nutrition.answer.title": "记下了：{name}",
    "nutrition.answer.thisFood": "这一份：{kcal} 千卡，糖 {sugar} 克。",
    "nutrition.answer.thisDrink": "这杯饮料：{kcal} 千卡，糖 {sugar} 克。",
    "nutrition.answer.breaksFast": "有热量，会打断你正在进行的轻断食（已坚持 {h} 小时 {m} 分钟）。要现在结束这次断食吗？",
    "nutrition.answer.keepsFast": "几乎没有热量，不影响轻断食，继续加油（已坚持 {h} 小时 {m} 分钟）。",
    "nutrition.answer.outsideWindow": "现在不在你的进食时间（{from}–{to}）。偶尔没关系，常这样会影响轻断食的效果。",
    "nutrition.answer.today": "今天到现在",
    "nutrition.answer.thatDay": "那一天",
    "nutrition.answer.left": "还剩 {n} {unit}",
    "nutrition.answer.over": "超出 {n} {unit}",
    "nutrition.answer.burned": "今天运动消耗了 {kcal} 千卡，已算进热量额度。",
    "nutrition.answer.ok": "好的",
    "nutrition.answer.keepFast": "不结束，继续断食",
    "nutrition.answer.endFast": "结束这次断食",
    "nutrition.answer.fastEnded": "轻断食已结束，进食时间开始",
    "nutrition.form.ateOut": "在外面吃或外卖？记下花了多少钱（会记进账本）",
    "nutrition.form.cost": "花了多少",
    "nutrition.form.place": "在哪里（可选）",
    "nutrition.form.placePh": "例如：川菜馆",
    "nutrition.answer.booked": "也记进了账本：{amount}（餐饮外卖）",
    "nutrition.hub.snap": "卡路里计算器",
    "nutrition.hub.snapSub": "每天 3 次：拍三餐，AI 估算卡路里和糖",
    "nutrition.hub.snapLeft": "每天 3 次，拍三餐估算卡路里和糖 · 今天还剩 {n} 次",
    "nutrition.snap.title": "卡路里计算器",
    "nutrition.snap.intro": "每天可以拍 3 次：拍你的三餐（早、午、晚），AI 估算这一餐吃了多少卡路里、糖和盐。",
    "nutrition.snap.liveScan": "直接扫条形码（对准就行）",
    "nutrition.snap.free": "包装食品请用“拍包装食品”：拍营养表或条形码，免费，不占这 3 次。",
    "nutrition.snap.looking": "正在看是什么…",
    "nutrition.snap.lookingPct": "正在识别… {pct}%",
    "nutrition.snap.notTable": "照片里没有条形码，也不像营养表。这是一餐饭吗？",
    "nutrition.snap.meal": "是一餐饭：用 AI 估算热量和糖",
    "nutrition.snap.mealLeft": "今天还可以估算 {n} 餐",
    "nutrition.snap.mealNone": "今天的估算次数用完了，可以手动填写",
    "nutrition.snap.mealNoneTrial": "试用期间每天估算 1 餐，今天已用完；可以手动填写",
    "nutrition.snap.label": "是营养表，只是没读出来：用 AI 帮读",
    "nutrition.snap.labelLeft": "本月还可帮读 {n} 次",
    "nutrition.snap.labelNone": "本月的 AI 帮读次数用完了",
    "nutrition.snap.manual": "自己填写（照片留着）",
    "nutrition.snap.again": "重新拍",
    "nutrition.form.readLabel": "从照片读出营养表（先在手机上免费识别）",
    "nutrition.snap.aiOff": "AI 暂未开通，可以自己填写",
    "nutrition.snap.aiPaused": "本月 AI 已暂停，1 日恢复；可以自己填写",
    "nutrition.saved": "已记下",
    "nutrition.footer": "数值仅供参考，不能替代医生或营养师的建议。",

    "nutrition.n.kcal": "热量",
    "nutrition.n.protein": "蛋白质",
    "nutrition.n.fat": "脂肪",
    "nutrition.n.carbs": "碳水化合物",
    "nutrition.n.sugar": "糖",
    "nutrition.n.freeSugar": "游离糖",
    "nutrition.n.salt": "盐",
    "nutrition.n.potassium": "钾",
    "nutrition.unit.kcal": "千卡",
    "nutrition.unit.g": "克",
    "nutrition.unit.mg": "毫克",

    "nutrition.meal.breakfast": "早餐",
    "nutrition.meal.lunch": "午餐",
    "nutrition.meal.dinner": "晚餐",
    "nutrition.meal.snack": "加餐",
    "nutrition.source.label": "营养标签",
    "nutrition.source.recipe": "精确计算",
    "nutrition.source.estimate": "估算",
    "nutrition.source.manual": "手动",
    "nutrition.basis.portion": "每份",
    "nutrition.basis.100g": "每 100 克",
    "nutrition.basis.100ml": "每 100 毫升",

    "nutrition.hero.title": "这一餐吃了多少？",
    "nutrition.hero.titleOn": "{date} 吃了什么？",
    "nutrition.hero.sub": "拍一下或扫一扫，马上知道这一餐占你一天所需的多少。",
    "nutrition.hero.count": "{n} 条记录 · {kcal} 千卡",
    "nutrition.hero.log": "记一餐",

    "nutrition.date.nav": "选择日期",
    "nutrition.date.prev": "前一天",
    "nutrition.date.next": "后一天",
    "nutrition.date.toToday": "回到今天",
    "nutrition.date.week": "最近 7 天的热量",
    "nutrition.date.nothing": "没有记录",

    "nutrition.again.title": "再来一份",

    "nutrition.summary.title": "当天合计",
    "nutrition.summary.all": "全部营养素",
    "nutrition.summary.fewer": "收起",
    "nutrition.summary.unknown": "暂无数据",
    "nutrition.summary.partial": "部分合计",
    "nutrition.summary.partialCount": "{n} 条记录缺少此项",
    "nutrition.summary.partialNote": "≈ 表示部分记录没有填写这一项，实际合计可能更高。",
    "nutrition.status.within": "在范围内",
    "nutrition.status.above": "超过上限",
    "nutrition.status.below": "低于下限",
    "nutrition.target.range": "目标 {min}–{max} {unit}",
    "nutrition.target.max": "上限 {max} {unit}",
    "nutrition.target.min": "至少 {min} {unit}",
    "nutrition.target.none": "未设目标",

    "nutrition.meals.title": "我的餐食",
    "nutrition.meals.addTo": "添加到{meal}",
    "nutrition.meals.empty": "记录{meal}",

    "nutrition.window.title": "进食时间",
    "nutrition.window.first": "第一口",
    "nutrition.window.last": "最后一口",
    "nutrition.window.span": "{h} 小时 {m} 分",
    "nutrition.window.note": "这里只记录你什么时候吃东西，不是医疗建议。打算尝试断食或调整饮食时间前，请先咨询医生。",

    "nutrition.tips.label": "小提示",
    "nutrition.tip.sugar.1.title": "今天的甜蜜额度用完啦",
    "nutrition.tip.sugar.1.body": "接下来口渴时，来杯白水或无糖茶吧。",
    "nutrition.tip.sugar.2.title": "糖分已经到顶了",
    "nutrition.tip.sugar.2.body": "嘴馋的话，一把坚果或一个苹果也很香。",
    "nutrition.tip.sugar.3.title": "甜品今天已经打卡",
    "nutrition.tip.sugar.3.body": "明天再约它吧，今天剩下的就交给蔬菜和水。",
    "nutrition.tip.kcal.1.title": "今天的能量已经加满",
    "nutrition.tip.kcal.1.body": "如果还饿，选点清淡的：一碗汤或一些蔬菜。",
    "nutrition.tip.kcal.2.title": "热量到达今日目标",
    "nutrition.tip.kcal.2.body": "饭后散散步，消化舒服，心情也好。",
    "nutrition.tip.kcal.3.title": "油箱满格啦",
    "nutrition.tip.kcal.3.body": "偶尔多一点没关系，明天照常就好。",
    "nutrition.tip.carbs.1.title": "碳水今天吃得很尽兴",
    "nutrition.tip.carbs.1.body": "下一餐可以多点蔬菜和蛋白质，少点米面。",
    "nutrition.tip.carbs.2.title": "主食额度到了",
    "nutrition.tip.carbs.2.body": "试试用全谷物替换精米白面，更耐饿。",
    "nutrition.tip.carbs.3.title": "米饭面条今天够数了",
    "nutrition.tip.carbs.3.body": "加餐不妨换成酸奶或一把坚果。",

    "nutrition.form.newTitle": "记一餐",
    "nutrition.form.editTitle": "修改记录",
    "nutrition.form.repeatTitle": "再来一份",
    "nutrition.form.photo": "照片（可选）",
    "nutrition.form.aiMode": "照片里是什么",
    "nutrition.form.aiLabel": "营养标签",
    "nutrition.form.aiMeal": "一盘饭菜",
    "nutrition.form.aiRead": "用 AI 读取照片",
    "nutrition.form.aiReading": "正在读取…",
    "nutrition.form.aiDoneLabel": "已按标签填好数值，请核对后保存。",
    "nutrition.form.aiDoneEstimate": "已填入估算值。照片估算只是大概，请核对后保存。",
    "nutrition.form.name": "吃了什么",
    "nutrition.form.namePlaceholder": "例如：原味酸奶",
    "nutrition.form.nameRequired": "请填写食物名称。",
    "nutrition.form.nameTooLong": "名称最多 {n} 个字符。",
    "nutrition.form.meal": "哪一餐",
    "nutrition.form.date": "日期",
    "nutrition.form.dateInvalid": "请选择有效日期。",
    "nutrition.form.dateFuture": "日期不能晚于今天。",
    "nutrition.form.time": "时间",
    "nutrition.form.timeInvalid": "请按 时:分 填写，例如 08:15。",
    "nutrition.form.basis": "这些数字是按",
    "nutrition.form.grams": "吃了多少（{unit}）",
    "nutrition.form.gramsHint": "保存时会按这个量换算成你实际吃的份量。",
    "nutrition.form.gramsInvalid": "请填写 0.1 到 10000 之间的数。",
    "nutrition.form.valuesPortion": "这一份的营养",
    "nutrition.form.valuesPer100": "每 100 {unit} 的营养",
    "nutrition.form.freeSugarHint": "添加糖、蜂蜜、糖浆和果汁里的糖",
    "nutrition.form.blankUnknown": "不知道的可以留空，留空表示“未知”，不是 0。",
    "nutrition.form.valueInvalid": "请填写 0 到 {max} 之间的数。",
    "nutrition.form.freeSugarTooHigh": "游离糖不能多于糖总量。",
    "nutrition.form.sugarTooHigh": "糖不能多于碳水化合物（糖本身就是碳水的一部分）。",
    "nutrition.form.scaledTooHigh": "换算后的数值太大，请检查份量。",
    "nutrition.form.trash": "移到回收站",
    "nutrition.form.repeat": "今天再记一份",

    "nutrition.goals.title": "我的目标",
    "nutrition.goals.goal": "我最想",
    "nutrition.goal.balanced": "均衡饮食",
    "nutrition.goal.weight": "控制体重",
    "nutrition.goal.sugar": "少糖",
    "nutrition.goal.salt": "少盐",
    "nutrition.goal.balanced.hint": "按世卫组织的健康饮食建议设定全部参考值。",
    "nutrition.goal.weight.hint": "把每日热量控制在你设定的上限以内。",
    "nutrition.goal.sugar.hint": "重点关注糖和游离糖；不设碳水范围。",
    "nutrition.goal.salt.hint": "重点关注盐，每天不超过 5 克。",
    "nutrition.goals.helper": "按指南自动填写",
    "nutrition.goals.helperIntro": "根据每日能量需求和体重，按世卫组织面向成年人的建议算出参考值。之后仍可逐项修改。",
    "nutrition.goals.energy": "每日能量",
    "nutrition.goals.energyHint": "1000–5000 千卡",
    "nutrition.goals.energyInvalid": "每日能量请填 1000 到 5000 千卡之间。",
    "nutrition.goals.weight": "体重",
    "nutrition.goals.weightHint": "30–300 千克",
    "nutrition.goals.weightInvalid": "体重请填 30 到 300 千克之间。",
    "nutrition.goals.adult": "我已成年（这些参考值只适用于成年人）",
    "nutrition.goals.adultRequired": "请先确认你已成年。",
    "nutrition.goals.potassium": "我的肾脏健康（会加上钾每天至少要吃的量；有肾病请不要勾选，先问医生）",
    "nutrition.goals.fill": "填入参考值",
    "nutrition.goals.filled": "已填入下方，检查一下再保存。",
    "nutrition.goals.perNutrient": "每项营养素",
    "nutrition.goals.perNutrientHint": "留空表示不设该项。",
    "nutrition.goals.min": "最少",
    "nutrition.goals.max": "最多",
    "nutrition.goals.noMin": "只设上限",
    "nutrition.goals.minAboveMax": "最少值不能大于最多值。",
    "nutrition.goals.valueInvalid": "请填写 0 到 100000 之间的数。",
    "nutrition.goals.fixErrors": "有几项需要修改，请看上面的提示。",
    "nutrition.goals.disclaimer": "这些是一般性参考，不是医疗建议。如有疾病、怀孕或特殊饮食，请听从医生的建议。",
    "nutrition.goals.saved": "目标已保存",
    "nutrition.goals.invite": "现在使用的是世卫组织的默认值：盐每天最多 5 克；游离糖世卫建议最多 50 克，最好不超过 25 克。设定自己的目标，看得更清楚。",
    "nutrition.goals.set": "设定我的目标",

    "nutrition.trash.open": "回收站（{n}）",
    "nutrition.trash.title": "已删除的记录",
    "nutrition.trash.intro": "可以恢复，也可以永久删除。",
    "nutrition.trash.empty": "回收站是空的",
    "nutrition.trash.confirmTitle": "永久删除？",
    "nutrition.trash.confirmBody": "“{name}”会被永久删除，无法恢复。",

    "nutrition.guide.title": "饮食参考与来源",
    "nutrition.guide.intro": "目标参考值来自世界卫生组织（WHO）对成年人的健康饮食建议：",
    "nutrition.guide.salt": "盐：每天少于 5 克（约一平茶匙）。",
    "nutrition.guide.sugar": "游离糖：少于总能量的 10%，最好低于 5%。",
    "nutrition.guide.fat": "脂肪：少于总能量的 30%。",
    "nutrition.guide.carbs": "碳水化合物：约占总能量的 45%–75%。",
    "nutrition.guide.potassium": "钾：每天至少 3510 毫克（有肾脏问题的人除外）。",
    "nutrition.guide.whoDiet": "世卫组织：健康饮食（实况报道）",
    "nutrition.guide.whoSugar": "世卫组织：成人和儿童糖摄入量指南",
    "nutrition.guide.estimates": "通过照片得到的数值是 AI 的估算，可能有偏差；标签读取也请自己核对。",
    "nutrition.guide.notMedical": "本功能不提供医疗建议。如有健康问题，请咨询医生或营养师。",
    "nutrition.guide.privacy": "你的饮食记录只有你自己能看到。",
    "nutrition.hero.logDrink": "记饮料",
    "nutrition.guide.short": "指南",
    "nutrition.fast.off": "轻断食已关闭",
    "nutrition.fast.offOpen": "打开设置",
    "nutrition.fast.settingsShort": "设置",
    "nutrition.fast.deleteTitle": "删除这次断食记录？",
    "nutrition.fast.deleteBody": "这条记录会被永久删除，无法恢复。",
    "nutrition.form.more": "更多营养数据 / 日期时间",
    "nutrition.form.moreHint": "蛋白质、脂肪、碳水、盐等，以及日期、时间和份量",
    "nutrition.form.reviewHint": "核对一下名称和餐次，数字可以修改，然后点“保存”。",
    "nutrition.form.labelIntro": "条形码 {code} 没有找到。拍下包装上的营养成分表，AI 会自动读出数字，你再核对一下。",
    "nutrition.form.labelIntroNoAi": "条形码 {code} 没有找到。请照着包装上的营养成分表填写数字。",
    "nutrition.scan.badCode": "条形码位数或校验位不对，请核对",
    "nutrition.photo.noAi": "现在没法拍照估算。",
    "nutrition.photo.noAiPlan": "你的账户目前没有 AI 识别次数。",
    "nutrition.photo.noAiAlt": "可以手动记录，包装食品也可以扫条形码。",
    "nutrition.photo.manual": "手动记录",
    "nutrition.month.exportEmpty": "本月还没有数据可导出",
    "nutrition.trash.row": "回收站",
    "nutrition.goals.estimate": "不知道？按体重估算",
    "nutrition.goals.estimateNeedWeight": "先在右边填上体重，就能估算。",
    "nutrition.goals.estimateResult": "粗略估算：体重 × 30 ≈ {kcal} 千卡。只是大概的数，活动多的人需要更多，想减重的人可以少一点。",
    "nutrition.goals.estimateUse": "用 {kcal} 千卡",
    "nutrition.goals.weightFromLog": "已按你最近记的体重填好",
    "nutrition.goals.advanced": "逐项调整（高级）",
  },
  en: {
    "nutrition.pantry.ask": "The pantry has “{name}”. Was this from home?",
    "nutrition.pantry.take": "Take from pantry",
    "nutrition.pantry.taken": "“{name}”: {qty} taken off the stock.",
    "nutrition.pantry.takenEst": "“{name}”: about {qty} taken off (no pack size, a usual amount — check in the pantry).",
    "nutrition.hub.todayList": "What I ate today",
    "nutrition.labelTips.title": "Photograph the nutrition table clearly — the photo is kept with the product:",
    "nutrition.labelTips.straight": "Hold the phone straight in front of the table, not at an angle",
    "nutrition.labelTips.sharp": "In focus, the text readable, no glare",
    "nutrition.labelTips.whole": "The whole table in the picture, including the “per 100 g” line",
    "nutrition.pack.name": "Product name",
    "nutrition.pack.namePh": "e.g. Wholegrain crackers",
    "nutrition.pack.storeTitle": "Bought to keep? Put it in the pantry",
    "nutrition.pack.storeHint": "The values and this photo go into the pantry; with a price, it is also booked in the family ledger.",
    "nutrition.pack.price": "Price (optional)",
    "nutrition.pack.storeBtn": "Put in the pantry",
    "nutrition.pack.needName": "Write the product's name first.",
    "nutrition.pack.stored": "In the pantry, with its values and photo.",
    "nutrition.pack.storedPaid": "In the pantry, and the price is in the family ledger.",
    "nutrition.pack.storedShort": "In the pantry",
    "nutrition.ex.workout": "Log a workout",
    "nutrition.hub.exerciseSub": "Steps, gym, running — and what they burned",
    "nutrition.balance.eaten": "Eaten",
    "nutrition.balance.burned": "Burned",
    "nutrition.balance.diff": "Balance",
    "nutrition.snap.tip1": "Straight: hold the phone right above the plate and shoot down.",
    "nutrition.snap.tip2": "Complete: the whole meal in the picture — every plate and bowl.",
    "nutrition.snap.tip3": "Bright: good light and in focus, for a good estimate.",
    "nutrition.balance.status": "Today's health:",
    "nutrition.balance.statusGood": "good 👍",
    "nutrition.balance.statusKcal": "{v} kcal over",
    "nutrition.balance.statusSugar": "too much sugar",
    "nutrition.balance.statusSalt": "too much salt",
    "nutrition.balance.statusNone": "nothing logged yet today",
    "nutrition.hub.steps": "Steps",
    "nutrition.hub.stepsSub": "Today's steps, turned into calories",
    "nutrition.hub.stepsToday": "{n} steps today",
    "nutrition.balance.title": "Today's energy balance",
    "nutrition.balance.setup": "Fill in your height, weight, age and everyday activity once, and the app works out how many calories you burn each day — against what you ate.",
    "nutrition.balance.setupBtn": "Fill in body details",
    "nutrition.balance.open": "Open today's energy balance",
    "nutrition.balance.sum": "Eaten {eaten} − burned {burned} = {diff} kcal",
    "nutrition.balance.deficit": "{v} kcal less than you burned: your weight goes down.",
    "nutrition.balance.surplus": "{v} kcal more than you burned: the extra is stored as fat.",
    "nutrition.balance.even": "Eaten and burned are about even: your weight stays. {left} kcal left in today's standard.",
    "nutrition.balance.parts": "Burned: {parts}",
    "nutrition.balance.partBase": "resting and daily life {v}",
    "nutrition.balance.partPhone": "activity from your phone {v}",
    "nutrition.balance.partSteps": "walking {steps} steps ≈ {v}",
    "nutrition.balance.partExercise": "workouts {v}",
    "nutrition.balance.stepsToday": "{n} steps today · edit",
    "nutrition.balance.addSteps": "Add today's steps and activity",
    "nutrition.balance.how": "See how it's worked out",
    "nutrition.balance.soFar": "The day isn't over: by your standard you can still eat {left} kcal today. Most accurate after dinner.",
    "nutrition.scan.noNumbers": "Found it, but the open food database has no nutrition for this product yet. Take a photo of the nutrition table on the pack and the app reads it on your phone (free). It's remembered, so anyone who scans this barcode later sees it straight away.",
    "nutrition.scan.labelPhoto": "Photo of the nutrition table",
    "nutrition.scan.labelFail": "That couldn’t be read. Try again with the table straight and sharp, or type the values in.",
    "nutrition.scan.typeIt": "Type it in",
    "nutrition.scan.fromLabel": "Nutrition read from a pack photo",
    "nutrition.ex.kcalShort": "{n} kcal",
    "nutrition.ex.todayList": "Logged today",
    "nutrition.ex.basisDefault": "No weight logged yet, so estimated for {kg} kg; log your weight for a better estimate.",
    "nutrition.ex.basis": "Estimated for your latest weight, {kg} kg, at a moderate pace.",
    "nutrition.ex.save": "Save: {kcal} kcal",
    "nutrition.ex.estimated": "Estimated from your weight — you can change it",
    "nutrition.ex.kcal": "Energy used (kcal)",
    "nutrition.ex.min": "{n} min",
    "nutrition.ex.minutes": "How many minutes",
    "nutrition.ex.other": "Other",
    "nutrition.ex.dance": "Dancing",
    "nutrition.ex.chores": "Housework & garden",
    "nutrition.ex.yoga": "Yoga",
    "nutrition.ex.gym": "Gym",
    "nutrition.ex.swim": "Swimming",
    "nutrition.ex.run": "Running",
    "nutrition.ex.cycle": "Cycling",
    "nutrition.ex.walk": "Walking",
    "nutrition.ex.kind": "Activity",
    "nutrition.ex.title": "Log exercise",
    "nutrition.ach.exercise": "Active on {days} days, {kcal} kcal used — great!",
    "nutrition.month.exerciseDays": "{n} active days",
    "nutrition.month.exercise": "Exercise",
    "nutrition.hub.burnedLine": "Exercise {burned} kcal · net intake {net} kcal",
    "nutrition.hub.exerciseToday": "{kcal} kcal today",
    "nutrition.hub.exercise": "Exercise",
    "nutrition.hub.photoNone": "None left today",
    "nutrition.hub.photoLeft": "{n} left today",
    "nutrition.pack.checkNumbers": "Your phone read these numbers from the photo — please compare them with the pack.",
    "nutrition.pack.useAi": "✨ Read with AI ({n} left)",
    "nutrition.pack.unreadable": "Couldn't read this nutrition table. Try again straight on and in good light, or another way:",
    "nutrition.pack.readingPhone": "Reading the nutrition table… {pct}%",
    "nutrition.pack.free": "Read on your phone: free, no AI credits used.",
    "nutrition.pack.toPantry": "Want to keep this product in the pantry? Put it in the pantry here",
    "nutrition.pack.howMuchMl": "How many ml do you drink?",
    "nutrition.pack.howMuch": "How many grams do you eat?",
    "nutrition.pack.level.high": "High",
    "nutrition.pack.level.medium": "Medium",
    "nutrition.pack.level.low": "Low",
    "nutrition.pack.perPortion": "Per portion",
    "nutrition.pack.per100ml": "Per 100 ml",
    "nutrition.pack.per100g": "Per 100 g",
    "nutrition.pack.table": "Nutrition",
    "nutrition.pack.product": "Packaged food",
    "nutrition.pack.reading": "Reading the label…",
    "nutrition.pack.intro": "Photograph the nutrition table on the pack, straight on and sharp. Your phone reads energy, carbs, sugar, fat, protein and salt per 100 g and marks what's high or low.",
    "nutrition.pack.title": "Snap packaged food",
    "nutrition.hub.goalsSet": "Set daily goals",
    "nutrition.hub.packSub": "Photo of the nutrition label or barcode — log how much you ate (free)",
    "nutrition.hub.pack": "Snap packaged food",
    "nutrition.hub.photo": "Snap a meal",
    "nutrition.hub.photoSub": "Calories & carbs",
    "nutrition.hub.scan": "Scan barcode",
    "nutrition.hub.scanSub": "Look up nutrition",
    "nutrition.hub.cook": "Cook a dish",
    "nutrition.hub.cookSub": "Cook with what's in the pantry: exact nutrition per serving",
    "nutrition.hub.manual": "Log by hand",
    "nutrition.hub.manualSub": "Type in what you ate and its calories",
    "nutrition.hub.drink": "Log a drink",
    "nutrition.hub.drinkSub": "Note each drink's calories and sugar",
    "nutrition.hub.drinkToday": "{n} today",
    "nutrition.hub.weight": "Weight",
    "nutrition.hub.weightSub": "Note your weight, see how it changes",
    "nutrition.hub.fasting": "Fasting",
    "nutrition.hub.fastingSub": "Set your eating window; timed for you",
    "nutrition.hub.fastingNow": "Fasting {h}:{m}",
    "nutrition.hub.day": "Today's food",
    "nutrition.hub.dayCount": "{n} entries",
    "nutrition.hub.dayNone": "Nothing yet",
    "nutrition.hub.month": "This month",
    "nutrition.hub.monthSub": "The month's eating report, to Excel",
    "nutrition.hub.goals": "My goals",
    "nutrition.hub.goalsKcal": "≤ {kcal} kcal a day",
    "nutrition.hub.goalsNone": "Not set yet",
    "nutrition.hub.today": "Today",
    "nutrition.hub.todayOpen": "Tap for details ›",
    "nutrition.impact.biggest": "Watch the {name}: {pct}% of your day",
    "nutrition.photo.button": "Snap this meal",
    "nutrition.photo.buttonSub": "Photo of your plate, AI estimate",
    "nutrition.scan.buttonBig": "Scan a barcode",
    "nutrition.scan.buttonSub": "Packaged food and drinks",
    "nutrition.hero.logManual": "Enter by hand",
    "nutrition.photo.title": "Snap this meal",
    "nutrition.photo.intro": "Fit the whole plate in the picture, in good light. The AI estimates the calories, sugar, fat and salt of this portion.",
    "nutrition.photo.reading": "Estimating this meal…",
    "nutrition.photo.readingTime": "Usually 5–15 seconds.",
    "nutrition.photo.grams": "About {g} g",
    "nutrition.photo.again": "Retake",
    "nutrition.photo.meal": "This meal",
    "nutrition.photo.estimateNote": "Photo estimates aren't exact; you can adjust them in the next step. For packaged food, scanning the barcode is more accurate.",
    "nutrition.impact.title": "How much of your day this meal is",
    "nutrition.impact.kcalLine": "{kcal} kcal, {pct}% of your day",
    "nutrition.impact.noKcal": "Calories unknown",
    "nutrition.impact.overToday": "With this meal you'll go over your daily {list}. Have a little less, or keep the next meal light.",
    "nutrition.impact.overDay": "With this meal that day goes over the {list} goal.",
    "nutrition.impact.leftToday": "After this meal you have {kcal} kcal left for today.",
    "nutrition.impact.leftDay": "With this meal that day has {kcal} kcal left.",
    "nutrition.impact.name.kcal": "Energy",
    "nutrition.impact.name.sugar": "sugar",
    "nutrition.impact.name.fat": "fat",
    "nutrition.impact.name.salt": "salt",
    "nutrition.impact.name.carbs": "carbs",
    "nutrition.impact.name.protein": "protein",
    "nutrition.impact.limitLeft": "{daily} {unit} a day, {n} {unit} left",
    "nutrition.impact.overBy": "{n} {unit} over",
    "nutrition.impact.needLeft": "{n} {unit} still to go today",
    "nutrition.impact.needMet": "Enough for today",
    "nutrition.impact.unknown": "Not known",
    "nutrition.impact.basisGoal": "Based on your daily goals; anything without a goal uses the EU adult reference intake. Light: already eaten today. Dark: this meal.",
    "nutrition.impact.basisRi": "Based on the adult reference intake printed on EU food packs: 2000 kcal, 70 g fat, 90 g sugar, 6 g salt. Light: already eaten today. Dark: this meal. Set your own under My goals.",
    "nutrition.month.title": "This month",
    "nutrition.month.prev": "Previous month",
    "nutrition.month.next": "Next month",
    "nutrition.month.noWeight": "No weight logged yet. Log today's weight as this month's starting point!",
    "nutrition.month.startedOn": "Starting point: {date}",
    "nutrition.month.logWeight": "Log weight",
    "nutrition.month.weightKg": "Weight (kg)",
    "nutrition.month.weightHint": "Weigh yourself at the same time each time, for example in the morning before breakfast.",
    "nutrition.month.weightSaved": "Weight saved",
    "nutrition.body.title": "My weight",
    "nutrition.body.kg": "kg",
    "nutrition.body.today": "Today",
    "nutrition.body.lastOn": "Last weighed: {date}",
    "nutrition.body.waistShort": "waist {cm} cm",
    "nutrition.body.none": "No weight logged yet. Weigh yourself each morning to see what your eating does.",
    "nutrition.body.sinceMonth": "Change this month",
    "nutrition.body.logToday": "Log today's weight",
    "nutrition.body.editToday": "Change today's weight",
    "nutrition.body.bmi.under": "Underweight",
    "nutrition.body.bmi.normal": "Healthy",
    "nutrition.body.bmi.over": "Overweight",
    "nutrition.body.bmi.obese": "Obesity",
    "nutrition.body.standard": "Standard weight",
    "nutrition.body.above": "{kg} kg above",
    "nutrition.body.below": "{kg} kg below",
    "nutrition.body.healthy": "Healthy range",
    "nutrition.body.askHeight": "Add your height to see your BMI and standard weight.",
    "nutrition.body.setHeight": "Add height",
    "nutrition.body.heightShort": "Height {cm}",
    "nutrition.body.height": "Height (cm)",
    "nutrition.body.heightHint": "Only once — used for BMI and standard weight",
    "nutrition.body.waist": "Waist (cm)",
    "nutrition.body.optional": "Optional",
    "nutrition.body.formula": "Standard weight = height (cm) − 105. The healthy range is BMI 18.5–24.9.",
    "nutrition.month.days": "Days logged",
    "nutrition.month.avgKcal": "Energy per day",
    "nutrition.month.avgSugar": "Sugar per day",
    "nutrition.month.drinkSugar": "Sugar from drinks",
    "nutrition.month.drinks": "{n} drinks · {kcal} kcal",
    "nutrition.month.fasts": "Fasts completed",
    "nutrition.month.longest": "Longest {h} h",
    "nutrition.month.sugarDays": "Days on sugar goal",
    "nutrition.month.sugarMax": "≤ {g} g a day",
    "nutrition.month.empty": "Nothing logged this month yet. Log your first meal and start collecting achievements!",
    "nutrition.month.export": "Export this month to Excel",
    "nutrition.month.exportHint": "Five sheets: overview with charts, daily details, weight & body, drinks and fasting.",
    "nutrition.ach.logged_days": "Logged your food on {days} days",
    "nutrition.ach.logging_streak": "{days} days in a row, great persistence!",
    "nutrition.ach.sugar_days": "{days} days within your sugar goal",
    "nutrition.ach.fasts_done": "Completed {count} fasts",
    "nutrition.ach.longest_fast": "Longest fast {hours} hours",
    "nutrition.ach.weight_lost": "Lost {kg} kg, well done!",
    "nutrition.ach.weight_steady": "Kept your weight steady",
    "nutrition.badge.streak7": "7-day streak",
    "nutrition.badge.logged20": "20 days logged",
    "nutrition.badge.sugar15": "Sugar star",
    "nutrition.badge.fast10": "Fasting pro",
    "nutrition.badge.fast18h": "18-hour challenge",
    "nutrition.badge.lost1kg": "1 kg lighter",
    "nutrition.meal.drink": "Drinks",
    "nutrition.scan.tipMedium": "Medium in {list}; keep an eye on the portion.",
    "nutrition.scan.tipPortionSugar": "This portion has about {g} g of sugar, {pct}% of the WHO's ideal daily limit for free sugars (25 g).",
    "nutrition.scan.tipNutriScore": "Nutri-Score {grade}: low nutritional quality. Have it less often, or pick a similar product with a better score.",
    "nutrition.scan.button": "Scan",
    "nutrition.scan.title": "Scan a food barcode",
    "nutrition.scan.hint": "Hold the barcode on the pack inside the frame. It's read automatically.",
    "nutrition.scan.slow": "Not working? Hold the barcode level, 15–20 cm away, without glare; on a curved bottle, turn it so the barcode faces the camera. Or take a photo below, or type the numbers under the barcode.",
    "nutrition.scan.starting": "Opening the camera…",
    "nutrition.scan.noCamera": "The camera couldn't be opened. Take a photo of the barcode, or type the numbers under it.",
    "nutrition.scan.photo": "Photo of the barcode",
    "nutrition.scan.manual": "Or type the barcode",
    "nutrition.scan.lookup": "Look up",
    "nutrition.scan.looking": "Looking up nutrition facts…",
    "nutrition.scan.notFound": "This product ({code}) isn't in the database yet. Take a photo of the nutrition label and let the AI read it.",
    "nutrition.scan.notFoundAction": "Photo of the label",
    "nutrition.scan.noCode": "No barcode found in the photo. Move closer, focus and try again.",
    "nutrition.scan.again": "Scan another",
    "nutrition.scan.per100g": "Per 100 g",
    "nutrition.scan.per100ml": "Per 100 ml",
    "nutrition.scan.amount": "How much did you have ({unit})",
    "nutrition.scan.serving": "One serving: {label}",
    "nutrition.scan.forAmount": "{amount}{unit} contains",
    "nutrition.scan.log": "Add to my meals",
    "nutrition.scan.source": "Nutrition facts from Open Food Facts, an open database. They may contain mistakes; the pack is leading.",
    "nutrition.scan.nutriScore": "Nutri-Score",
    "nutrition.scan.kcal": "Energy",
    "nutrition.scan.tipHigh": "High in {list}. Fine now and then; watch the portion and add some vegetables.",
    "nutrition.scan.tipOk": "Not high in fat, sugar or salt. A good choice.",
    "nutrition.scan.sep": ", ",
    "nutrition.level.low": "Low",
    "nutrition.level.medium": "Med",
    "nutrition.level.high": "High",
    "nutrition.light.fat": "fat",
    "nutrition.light.saturatedFat": "saturated fat",
    "nutrition.light.sugar": "sugar",
    "nutrition.light.salt": "salt",
    "nutrition.fast.title": "Intermittent fasting",
    "nutrition.fast.setup": "Set up fasting",
    "nutrition.fast.settings": "Fasting settings",
    "nutrition.fast.intro": "Pick a plan, for example 16:8: eat within 8 hours each day and have only water, tea or black coffee for the other 16.",
    "nutrition.fast.plan": "Plan",
    "nutrition.fast.planDesc": "Fast {fast} h · eat {eat} h",
    "nutrition.fast.eatStart": "Eating starts at",
    "nutrition.fast.window": "Eating {start}–{end}",
    "nutrition.fast.show": "Show fasting on the meals page",
    "nutrition.fast.saved": "Fasting settings saved",
    "nutrition.fast.status.fasting": "Fasting",
    "nutrition.fast.status.reached": "Goal reached",
    "nutrition.fast.status.eating": "Eating window",
    "nutrition.fast.status.idle": "Not fasting yet",
    "nutrition.fast.elapsed": "Fasting for {h} h {m} min",
    "nutrition.fast.remaining": "{h} h {m} min to go",
    "nutrition.fast.closesIn": "Eating window closes in {h} h {m} min",
    "nutrition.fast.opensIn": "Eating window opens in {h} h {m} min",
    "nutrition.fast.goal": "Goal {h} h",
    "nutrition.fast.start": "Start fasting",
    "nutrition.fast.startEarlier": "I started earlier",
    "nutrition.fast.startTime": "Start time",
    "nutrition.fast.end": "End fast",
    "nutrition.fast.endEarly": "End early",
    "nutrition.fast.editStart": "Change start",
    "nutrition.fast.streak": "{n}-day streak",
    "nutrition.fast.history": "Recent fasts",
    "nutrition.fast.duration": "{h} h {m} min",
    "nutrition.fast.reachedShort": "Reached",
    "nutrition.fast.short": "Short",
    "nutrition.fast.delete": "Delete",
    "nutrition.fast.ended": "Fast ended after {h} h {m} min.",
    "nutrition.fast.endedReached": "Well done! You fasted {h} h {m} min.",
    "nutrition.fast.caution": "Fasting isn't suitable during pregnancy or breastfeeding, with diabetes (especially on medication), with a history of eating disorders, or for children. If you have health problems, ask your doctor first. Drink plenty of water and stop if you feel unwell.",
    "nutrition.title": "Meals",
    "nutrition.answer.title": "Logged: {name}",
    "nutrition.answer.thisFood": "This portion: {kcal} kcal, {sugar} g sugar.",
    "nutrition.answer.thisDrink": "This drink: {kcal} kcal, {sugar} g sugar.",
    "nutrition.answer.breaksFast": "It has calories, so it breaks the fast you are doing ({h} h {m} min so far). End the fast now?",
    "nutrition.answer.keepsFast": "Practically no calories: your fast goes on ({h} h {m} min so far).",
    "nutrition.answer.outsideWindow": "This is outside your eating window ({from}–{to}). Now and then is fine; often makes fasting less effective.",
    "nutrition.answer.today": "Today so far",
    "nutrition.answer.thatDay": "That day",
    "nutrition.answer.left": "{n} {unit} left",
    "nutrition.answer.over": "{n} {unit} over",
    "nutrition.answer.burned": "Exercise burned {kcal} kcal today; it is added to your calories.",
    "nutrition.answer.ok": "OK",
    "nutrition.answer.keepFast": "Keep fasting",
    "nutrition.answer.endFast": "End the fast",
    "nutrition.answer.fastEnded": "Fast ended; eating time starts",
    "nutrition.form.ateOut": "Eaten out or a takeaway? Note what it cost (goes into the budget)",
    "nutrition.form.cost": "What it cost",
    "nutrition.form.place": "Where (optional)",
    "nutrition.form.placePh": "e.g. Pizzeria Napoli",
    "nutrition.answer.booked": "Also in the budget: {amount} (eating out)",
    "nutrition.hub.snap": "Calorie calculator",
    "nutrition.hub.snapSub": "3 times a day: snap your meals, AI estimates calories and sugar",
    "nutrition.hub.snapLeft": "3 a day: snap your meals for calories and sugar · {n} left today",
    "nutrition.snap.title": "Calorie calculator",
    "nutrition.snap.intro": "3 times a day: photograph your three meals (breakfast, lunch, dinner) and the AI estimates the calories, sugar and salt of the meal.",
    "nutrition.snap.liveScan": "Scan a barcode live",
    "nutrition.snap.free": "For packaged food use “Snap packaged food”: label or barcode, free, not one of the 3.",
    "nutrition.snap.looking": "Working out what it is…",
    "nutrition.snap.lookingPct": "Reading… {pct}%",
    "nutrition.snap.notTable": "No barcode or nutrition table in this photo. Is it a meal?",
    "nutrition.snap.meal": "A meal: estimate it with the AI",
    "nutrition.snap.mealLeft": "{n} meal estimates left today",
    "nutrition.snap.mealNone": "No estimates left today; fill it in yourself",
    "nutrition.snap.mealNoneTrial": "The trial includes 1 estimate a day, used today; fill it in yourself",
    "nutrition.snap.label": "It is a nutrition table: let the AI read it",
    "nutrition.snap.labelLeft": "{n} reading helps left this month",
    "nutrition.snap.labelNone": "No reading helps left this month",
    "nutrition.snap.manual": "Fill it in myself (keep the photo)",
    "nutrition.snap.again": "Take another photo",
    "nutrition.form.readLabel": "Read the nutrition table from the photo (on the phone first, free)",
    "nutrition.snap.aiOff": "AI is not available; fill it in yourself",
    "nutrition.snap.aiPaused": "AI is paused this month (back on the 1st); fill it in yourself",
    "nutrition.saved": "Logged",
    "nutrition.footer": "Values are a guide only and don't replace advice from a doctor or dietitian.",

    "nutrition.n.kcal": "Energy",
    "nutrition.n.protein": "Protein",
    "nutrition.n.fat": "Fat",
    "nutrition.n.carbs": "Carbohydrates",
    "nutrition.n.sugar": "Sugars",
    "nutrition.n.freeSugar": "Free sugars",
    "nutrition.n.salt": "Salt",
    "nutrition.n.potassium": "Potassium",
    "nutrition.unit.kcal": "kcal",
    "nutrition.unit.g": "g",
    "nutrition.unit.mg": "mg",

    "nutrition.meal.breakfast": "Breakfast",
    "nutrition.meal.lunch": "Lunch",
    "nutrition.meal.dinner": "Dinner",
    "nutrition.meal.snack": "Snacks",
    "nutrition.source.label": "Label",
    "nutrition.source.recipe": "Calculated",
    "nutrition.source.estimate": "Estimate",
    "nutrition.source.manual": "Manual",
    "nutrition.basis.portion": "Per portion",
    "nutrition.basis.100g": "Per 100 g",
    "nutrition.basis.100ml": "Per 100 ml",

    "nutrition.hero.title": "What's in this meal?",
    "nutrition.hero.titleOn": "What did you eat on {date}?",
    "nutrition.hero.sub": "Snap it or scan it, and see right away how much of your day it takes.",
    "nutrition.hero.count": "{n} entries · {kcal} kcal",
    "nutrition.hero.log": "Log a meal",

    "nutrition.date.nav": "Choose a day",
    "nutrition.date.prev": "Previous day",
    "nutrition.date.next": "Next day",
    "nutrition.date.toToday": "Today",
    "nutrition.date.week": "Calories over the last 7 days",
    "nutrition.date.nothing": "nothing logged",

    "nutrition.again.title": "Have it again",

    "nutrition.summary.title": "Day total",
    "nutrition.summary.all": "All nutrients",
    "nutrition.summary.fewer": "Show fewer",
    "nutrition.summary.unknown": "No data yet",
    "nutrition.summary.partial": "Partial total",
    "nutrition.summary.partialCount": "Missing in {n} entries",
    "nutrition.summary.partialNote": "≈ means some entries don't include this value, so the real total may be higher.",
    "nutrition.status.within": "On track",
    "nutrition.status.above": "Above max",
    "nutrition.status.below": "Below min",
    "nutrition.target.range": "target {min}–{max} {unit}",
    "nutrition.target.max": "max {max} {unit}",
    "nutrition.target.min": "at least {min} {unit}",
    "nutrition.target.none": "No goal set",

    "nutrition.meals.title": "My meals",
    "nutrition.meals.addTo": "Add to {meal}",
    "nutrition.meals.empty": "Add {meal}",

    "nutrition.window.title": "Eating times",
    "nutrition.window.first": "First bite",
    "nutrition.window.last": "Last bite",
    "nutrition.window.span": "{h} h {m} min",
    "nutrition.window.note": "This just shows when you ate — it isn't medical advice. Talk to your doctor before trying fasting or changing when you eat.",

    "nutrition.tips.label": "Friendly tips",
    "nutrition.tip.sugar.1.title": "Sweet tooth: fully served",
    "nutrition.tip.sugar.1.body": "Thirsty later? Water or unsweetened tea will do the trick.",
    "nutrition.tip.sugar.2.title": "Today's sugar jar is empty",
    "nutrition.tip.sugar.2.body": "Craving something? A handful of nuts or an apple hits the spot too.",
    "nutrition.tip.sugar.3.title": "Dessert has clocked in for today",
    "nutrition.tip.sugar.3.body": "Book it again tomorrow — veggies and water can take the rest of today.",
    "nutrition.tip.kcal.1.title": "Tank's full for today",
    "nutrition.tip.kcal.1.body": "Still peckish? Go light: a bowl of soup or some veg.",
    "nutrition.tip.kcal.2.title": "Energy goal reached",
    "nutrition.tip.kcal.2.body": "A short walk after dinner feels good and helps digestion.",
    "nutrition.tip.kcal.3.title": "That's a well-fed day",
    "nutrition.tip.kcal.3.body": "A bit extra now and then is fine — tomorrow is a fresh page.",
    "nutrition.tip.carbs.1.title": "Carbs had a great day",
    "nutrition.tip.carbs.1.body": "Next meal, try more veg and protein and a bit less bread or pasta.",
    "nutrition.tip.carbs.2.title": "Carb quota reached",
    "nutrition.tip.carbs.2.body": "Wholegrain swaps keep you full for longer.",
    "nutrition.tip.carbs.3.title": "Pasta, bread and rice: all present",
    "nutrition.tip.carbs.3.body": "For a snack, yoghurt or a few nuts make a nice change.",

    "nutrition.form.newTitle": "Log a meal",
    "nutrition.form.editTitle": "Edit entry",
    "nutrition.form.repeatTitle": "Have it again",
    "nutrition.form.photo": "Photo (optional)",
    "nutrition.form.aiMode": "What's in the photo",
    "nutrition.form.aiLabel": "Nutrition label",
    "nutrition.form.aiMeal": "Plate of food",
    "nutrition.form.aiRead": "Read photo with AI",
    "nutrition.form.aiReading": "Reading…",
    "nutrition.form.aiDoneLabel": "Filled in from the label. Please check before saving.",
    "nutrition.form.aiDoneEstimate": "Filled in with estimates. Photo estimates are rough, so please check before saving.",
    "nutrition.form.name": "What did you eat?",
    "nutrition.form.namePlaceholder": "e.g. Plain yoghurt",
    "nutrition.form.nameRequired": "Please enter what you ate.",
    "nutrition.form.nameTooLong": "Keep the name under {n} characters.",
    "nutrition.form.meal": "Meal",
    "nutrition.form.date": "Date",
    "nutrition.form.dateInvalid": "Please pick a valid date.",
    "nutrition.form.dateFuture": "The date can't be after today.",
    "nutrition.form.time": "Time",
    "nutrition.form.timeInvalid": "Use hours and minutes, e.g. 08:15.",
    "nutrition.form.basis": "These numbers are",
    "nutrition.form.grams": "How much did you eat ({unit})",
    "nutrition.form.gramsHint": "We'll work out the values for this amount when you save.",
    "nutrition.form.gramsInvalid": "Enter an amount between 0.1 and 10000.",
    "nutrition.form.valuesPortion": "Nutrition for this portion",
    "nutrition.form.valuesPer100": "Nutrition per 100 {unit}",
    "nutrition.form.freeSugarHint": "Added sugar, honey, syrups and fruit juice",
    "nutrition.form.blankUnknown": "Leave a field empty if you don't know it — empty means unknown, not zero.",
    "nutrition.form.valueInvalid": "Enter a number from 0 to {max}.",
    "nutrition.form.freeSugarTooHigh": "Free sugars can't be more than total sugars.",
    "nutrition.form.sugarTooHigh": "Sugars can't be more than carbohydrates (sugar is part of the carbs).",
    "nutrition.form.scaledTooHigh": "That amount gives values that are too high. Please check it.",
    "nutrition.form.trash": "Move to trash",
    "nutrition.form.repeat": "Log this again today",

    "nutrition.goals.title": "My goals",
    "nutrition.goals.goal": "What I want most",
    "nutrition.goal.balanced": "Balanced",
    "nutrition.goal.weight": "Weight",
    "nutrition.goal.sugar": "Less sugar",
    "nutrition.goal.salt": "Less salt",
    "nutrition.goal.balanced.hint": "All reference values from WHO's healthy diet advice.",
    "nutrition.goal.weight.hint": "Keep daily calories under the limit you set.",
    "nutrition.goal.sugar.hint": "Focus on sugars and free sugars; no carbohydrate range.",
    "nutrition.goal.salt.hint": "Focus on salt: no more than 5 g a day.",
    "nutrition.goals.helper": "Fill in guideline values",
    "nutrition.goals.helperIntro": "We use your daily energy needs and body weight to work out WHO reference values for adults. You can still change each one afterwards.",
    "nutrition.goals.energy": "Daily energy",
    "nutrition.goals.energyHint": "1000–5000 kcal",
    "nutrition.goals.energyInvalid": "Enter a daily energy between 1000 and 5000 kcal.",
    "nutrition.goals.weight": "Body weight",
    "nutrition.goals.weightHint": "30–300 kg",
    "nutrition.goals.weightInvalid": "Enter a weight between 30 and 300 kg.",
    "nutrition.goals.adult": "I'm an adult (these values are for adults only)",
    "nutrition.goals.adultRequired": "Please confirm you're an adult first.",
    "nutrition.goals.potassium": "My kidneys are healthy (adds a daily minimum for potassium; leave unticked if you have kidney disease and ask your doctor)",
    "nutrition.goals.fill": "Fill in values",
    "nutrition.goals.filled": "Filled in below. Have a look, then save.",
    "nutrition.goals.perNutrient": "Per nutrient",
    "nutrition.goals.perNutrientHint": "Leave empty for no limit.",
    "nutrition.goals.min": "Min",
    "nutrition.goals.max": "Max",
    "nutrition.goals.noMin": "Max only",
    "nutrition.goals.minAboveMax": "The minimum can't be higher than the maximum.",
    "nutrition.goals.valueInvalid": "Enter a number from 0 to 100000.",
    "nutrition.goals.fixErrors": "A few values need a fix — see the notes above.",
    "nutrition.goals.disclaimer": "These are general guidelines, not medical advice. If you have a health condition, are pregnant or follow a special diet, go by your doctor's advice.",
    "nutrition.goals.saved": "Goals saved",
    "nutrition.goals.invite": "You're seeing WHO defaults: salt max 5 g a day; for free sugars the WHO says at most 50 g, ideally no more than 25 g. Set your own goals for a clearer picture.",
    "nutrition.goals.set": "Set my goals",

    "nutrition.trash.open": "Trash ({n})",
    "nutrition.trash.title": "Deleted entries",
    "nutrition.trash.intro": "Restore an entry or delete it for good.",
    "nutrition.trash.empty": "Trash is empty",
    "nutrition.trash.confirmTitle": "Delete for good?",
    "nutrition.trash.confirmBody": "“{name}” will be deleted permanently. This can't be undone.",

    "nutrition.guide.title": "Guidance & sources",
    "nutrition.guide.intro": "The reference values follow the World Health Organization's (WHO) healthy diet advice for adults:",
    "nutrition.guide.salt": "Salt: less than 5 g a day (about a level teaspoon).",
    "nutrition.guide.sugar": "Free sugars: less than 10% of energy, ideally under 5%.",
    "nutrition.guide.fat": "Fat: less than 30% of energy.",
    "nutrition.guide.carbs": "Carbohydrates: about 45–75% of energy.",
    "nutrition.guide.potassium": "Potassium: at least 3510 mg a day (unless you have kidney problems).",
    "nutrition.guide.whoDiet": "WHO: Healthy diet fact sheet",
    "nutrition.guide.whoSugar": "WHO: Sugars intake for adults and children",
    "nutrition.guide.estimates": "Values from photos are AI estimates and can be off. Check label readings yourself too.",
    "nutrition.guide.notMedical": "This isn't medical advice. For health questions, talk to a doctor or dietitian.",
    "nutrition.guide.privacy": "Only you can see your meal diary.",
    "nutrition.hero.logDrink": "Log a drink",
    "nutrition.guide.short": "Guide",
    "nutrition.fast.off": "Fasting is off",
    "nutrition.fast.offOpen": "Open settings",
    "nutrition.fast.settingsShort": "Settings",
    "nutrition.fast.deleteTitle": "Delete this fast?",
    "nutrition.fast.deleteBody": "This entry will be deleted permanently. This can't be undone.",
    "nutrition.form.more": "More nutrients / date & time",
    "nutrition.form.moreHint": "Protein, fat, carbs, salt and more, plus date, time and amount",
    "nutrition.form.reviewHint": "Check the name and meal, adjust the numbers if needed, then tap “Save”.",
    "nutrition.form.labelIntro": "Barcode {code} wasn't found. Take a photo of the nutrition label on the pack and the AI will read the numbers; then check them.",
    "nutrition.form.labelIntroNoAi": "Barcode {code} wasn't found. Copy the numbers from the nutrition label on the pack.",
    "nutrition.scan.badCode": "The number of digits or the check digit is wrong. Please check the barcode.",
    "nutrition.photo.noAi": "Photo estimates aren't available right now.",
    "nutrition.photo.noAiPlan": "Your account has no AI reads at the moment.",
    "nutrition.photo.noAiAlt": "You can enter it by hand, or scan the barcode of packaged food.",
    "nutrition.photo.manual": "Enter by hand",
    "nutrition.month.exportEmpty": "Nothing to export for this month yet",
    "nutrition.trash.row": "Trash",
    "nutrition.goals.estimate": "Not sure? Estimate from weight",
    "nutrition.goals.estimateNeedWeight": "Enter your body weight first to get an estimate.",
    "nutrition.goals.estimateResult": "Rough estimate: weight × 30 ≈ {kcal} kcal. Only a ballpark: active people need more, and less helps if you want to lose weight.",
    "nutrition.goals.estimateUse": "Use {kcal} kcal",
    "nutrition.goals.weightFromLog": "Filled in from your latest logged weight",
    "nutrition.goals.advanced": "Adjust each nutrient (advanced)",
  },
  nl: {
    "nutrition.pantry.ask": "De voorraad heeft „{name}”. Kwam dit van thuis?",
    "nutrition.pantry.take": "Van voorraad af",
    "nutrition.pantry.taken": "„{name}”: {qty} van de voorraad af.",
    "nutrition.pantry.takenEst": "„{name}”: ongeveer {qty} van de voorraad af (geen verpakkingsgewicht — controleer in de voorraad).",
    "nutrition.hub.todayList": "Wat ik vandaag at",
    "nutrition.labelTips.title": "Fotografeer de voedingstabel duidelijk — de foto wordt bij het product bewaard:",
    "nutrition.labelTips.straight": "Houd de telefoon recht voor de tabel, niet schuin",
    "nutrition.labelTips.sharp": "Scherp, de tekst leesbaar, zonder schittering",
    "nutrition.labelTips.whole": "De hele tabel in beeld, ook de regel „per 100 g”",
    "nutrition.pack.name": "Productnaam",
    "nutrition.pack.namePh": "bijv. Volkoren crackers",
    "nutrition.pack.storeTitle": "Gekocht om te bewaren? Zet het in de voorraad",
    "nutrition.pack.storeHint": "De waarden en deze foto gaan in de voorraad; met een prijs komt het ook in het huishoudboekje.",
    "nutrition.pack.price": "Prijs (optioneel)",
    "nutrition.pack.storeBtn": "In de voorraad",
    "nutrition.pack.needName": "Vul eerst de productnaam in.",
    "nutrition.pack.stored": "In de voorraad, met waarden en foto.",
    "nutrition.pack.storedPaid": "In de voorraad, en de prijs staat in het huishoudboekje.",
    "nutrition.pack.storedShort": "In de voorraad",
    "nutrition.ex.workout": "Een training noteren",
    "nutrition.hub.exerciseSub": "Stappen, sportschool, hardlopen — en het verbruik",
    "nutrition.balance.eaten": "Gegeten",
    "nutrition.balance.burned": "Verbrand",
    "nutrition.balance.diff": "Verschil",
    "nutrition.snap.tip1": "Recht: houd de telefoon recht boven het bord en fotografeer naar beneden.",
    "nutrition.snap.tip2": "Compleet: de hele maaltijd in beeld — elk bord en elke kom.",
    "nutrition.snap.tip3": "Helder: genoeg licht en scherp, voor een goede schatting.",
    "nutrition.balance.status": "Gezondheid vandaag:",
    "nutrition.balance.statusGood": "goed 👍",
    "nutrition.balance.statusKcal": "{v} kcal te veel",
    "nutrition.balance.statusSugar": "te veel suiker",
    "nutrition.balance.statusSalt": "te veel zout",
    "nutrition.balance.statusNone": "vandaag nog niets genoteerd",
    "nutrition.hub.steps": "Stappen",
    "nutrition.hub.stepsSub": "Stappen van vandaag, omgerekend in calorieën",
    "nutrition.hub.stepsToday": "{n} stappen vandaag",
    "nutrition.balance.title": "Energiebalans van vandaag",
    "nutrition.balance.setup": "Vul één keer je lengte, gewicht, leeftijd en dagelijkse activiteit in, dan rekent de app uit hoeveel calorieën je per dag verbruikt — tegenover wat je at.",
    "nutrition.balance.setupBtn": "Lichaamsgegevens invullen",
    "nutrition.balance.open": "Energiebalans van vandaag openen",
    "nutrition.balance.sum": "Gegeten {eaten} − verbruikt {burned} = {diff} kcal",
    "nutrition.balance.deficit": "{v} kcal minder dan verbruikt: je gewicht gaat omlaag.",
    "nutrition.balance.surplus": "{v} kcal meer dan verbruikt: het teveel wordt als vet opgeslagen.",
    "nutrition.balance.even": "Gegeten en verbruikt zijn ongeveer gelijk: je gewicht blijft. Nog {left} kcal binnen je norm van vandaag.",
    "nutrition.balance.parts": "Verbruikt: {parts}",
    "nutrition.balance.partBase": "rust en dagelijks leven {v}",
    "nutrition.balance.partPhone": "activiteit van je telefoon {v}",
    "nutrition.balance.partSteps": "lopen {steps} stappen ≈ {v}",
    "nutrition.balance.partExercise": "sport {v}",
    "nutrition.balance.stepsToday": "{n} stappen vandaag · wijzigen",
    "nutrition.balance.addSteps": "Stappen en activiteit van vandaag toevoegen",
    "nutrition.balance.how": "Bekijk de berekening",
    "nutrition.balance.soFar": "De dag is nog niet voorbij: volgens je norm kun je vandaag nog {left} kcal eten. Na het avondeten het nauwkeurigst.",
    "nutrition.scan.noNumbers": "Gevonden, maar de open voedingsdatabase heeft nog geen voedingswaarden voor dit product. Maak een foto van de voedingswaardetabel op de verpakking; de app leest die op je telefoon (gratis). Het wordt onthouden, zodat iedereen die deze streepjescode later scant het meteen ziet.",
    "nutrition.scan.labelPhoto": "Foto van de voedingswaardetabel",
    "nutrition.scan.labelFail": "Dat was niet leesbaar. Probeer het opnieuw met de tabel recht en scherp, of vul het zelf in.",
    "nutrition.scan.typeIt": "Zelf invullen",
    "nutrition.scan.fromLabel": "Voedingswaarde gelezen van een verpakkingsfoto",
    "nutrition.ex.kcalShort": "{n} kcal",
    "nutrition.ex.todayList": "Vandaag ingevuld",
    "nutrition.ex.basisDefault": "Nog geen gewicht ingevuld, dus geschat voor {kg} kg; vul je gewicht in voor een betere schatting.",
    "nutrition.ex.basis": "Geschat voor je laatste gewicht, {kg} kg, in een gemiddeld tempo.",
    "nutrition.ex.save": "Opslaan: {kcal} kcal",
    "nutrition.ex.estimated": "Geschat op je gewicht — je kunt het aanpassen",
    "nutrition.ex.kcal": "Verbruikt (kcal)",
    "nutrition.ex.min": "{n} min",
    "nutrition.ex.minutes": "Hoeveel minuten",
    "nutrition.ex.other": "Overig",
    "nutrition.ex.dance": "Dansen",
    "nutrition.ex.chores": "Huishouden & tuin",
    "nutrition.ex.yoga": "Yoga",
    "nutrition.ex.gym": "Fitness",
    "nutrition.ex.swim": "Zwemmen",
    "nutrition.ex.run": "Hardlopen",
    "nutrition.ex.cycle": "Fietsen",
    "nutrition.ex.walk": "Wandelen",
    "nutrition.ex.kind": "Activiteit",
    "nutrition.ex.title": "Beweging invullen",
    "nutrition.ach.exercise": "{days} dagen actief, {kcal} kcal verbruikt — top!",
    "nutrition.month.exerciseDays": "{n} actieve dagen",
    "nutrition.month.exercise": "Beweging",
    "nutrition.hub.burnedLine": "Beweging {burned} kcal · netto {net} kcal",
    "nutrition.hub.exerciseToday": "{kcal} kcal vandaag",
    "nutrition.hub.exercise": "Beweging",
    "nutrition.hub.photoNone": "Vandaag op",
    "nutrition.hub.photoLeft": "Nog {n} vandaag",
    "nutrition.pack.checkNumbers": "Je telefoon heeft deze getallen van de foto gelezen — vergelijk ze even met de verpakking.",
    "nutrition.pack.useAi": "✨ Lezen met AI (nog {n})",
    "nutrition.pack.unreadable": "Deze voedingswaardetabel kon niet gelezen worden. Probeer het recht van voren met goed licht, of op een andere manier:",
    "nutrition.pack.readingPhone": "Voedingswaarde wordt gelezen… {pct}%",
    "nutrition.pack.free": "Gelezen op je telefoon: gratis, zonder AI-tegoed.",
    "nutrition.pack.toPantry": "Wil je dit product in de voorraad bewaren? Zet het hier in de voorraad",
    "nutrition.pack.howMuchMl": "Hoeveel ml drink je?",
    "nutrition.pack.howMuch": "Hoeveel gram eet je?",
    "nutrition.pack.level.high": "Hoog",
    "nutrition.pack.level.medium": "Gemiddeld",
    "nutrition.pack.level.low": "Laag",
    "nutrition.pack.perPortion": "Per portie",
    "nutrition.pack.per100ml": "Per 100 ml",
    "nutrition.pack.per100g": "Per 100 g",
    "nutrition.pack.table": "Voedingswaarde",
    "nutrition.pack.product": "Verpakt product",
    "nutrition.pack.reading": "Etiket wordt gelezen…",
    "nutrition.pack.intro": "Fotografeer de voedingswaardetabel op de verpakking, recht van voren en scherp. Je telefoon leest energie, koolhydraten, suiker, vet, eiwit en zout per 100 g en laat zien wat hoog of laag is.",
    "nutrition.pack.title": "Verpakt eten fotograferen",
    "nutrition.hub.goalsSet": "Dagdoelen instellen",
    "nutrition.hub.packSub": "Foto van het etiket of de streepjescode — noteer hoeveel je at (gratis)",
    "nutrition.hub.pack": "Verpakt eten fotograferen",
    "nutrition.hub.photo": "Foto van je bord",
    "nutrition.hub.photoSub": "Calorieën & koolhydraten",
    "nutrition.hub.scan": "Barcode scannen",
    "nutrition.hub.scanSub": "Voedingswaarde opzoeken",
    "nutrition.hub.cook": "Iets koken",
    "nutrition.hub.cookSub": "Koken met je voorraad: precieze voedingswaarde per portie",
    "nutrition.hub.manual": "Zelf invullen",
    "nutrition.hub.manualSub": "Typ zelf in wat je at en hoeveel calorieën",
    "nutrition.hub.drink": "Drankje",
    "nutrition.hub.drinkSub": "Noteer calorieën en suiker van elk drankje",
    "nutrition.hub.drinkToday": "{n} vandaag",
    "nutrition.hub.weight": "Gewicht",
    "nutrition.hub.weightSub": "Noteer je gewicht, zie het verloop",
    "nutrition.hub.fasting": "Vasten",
    "nutrition.hub.fastingSub": "Stel je eettijden in; de app houdt de tijd bij",
    "nutrition.hub.fastingNow": "Vast al {h}:{m}",
    "nutrition.hub.day": "Wat ik vandaag at",
    "nutrition.hub.dayCount": "{n} items",
    "nutrition.hub.dayNone": "Nog niets",
    "nutrition.hub.month": "Deze maand",
    "nutrition.hub.monthSub": "Het eetrapport van de maand, naar Excel",
    "nutrition.hub.goals": "Mijn doelen",
    "nutrition.hub.goalsKcal": "≤ {kcal} kcal per dag",
    "nutrition.hub.goalsNone": "Nog niet ingesteld",
    "nutrition.hub.today": "Vandaag",
    "nutrition.hub.todayOpen": "Tik voor details ›",
    "nutrition.impact.biggest": "Let op de {name}: {pct}% van je dag",
    "nutrition.photo.button": "Foto van je maaltijd",
    "nutrition.photo.buttonSub": "Foto van je bord, AI-schatting",
    "nutrition.scan.buttonBig": "Streepjescode scannen",
    "nutrition.scan.buttonSub": "Verpakt eten en drinken",
    "nutrition.hero.logManual": "Zelf invullen",
    "nutrition.photo.title": "Foto van je maaltijd",
    "nutrition.photo.intro": "Zet het hele bord op de foto, met goed licht. De AI schat de calorieën, suiker, vet en zout van deze portie.",
    "nutrition.photo.reading": "Maaltijd inschatten…",
    "nutrition.photo.readingTime": "Meestal 5–15 seconden.",
    "nutrition.photo.grams": "Ongeveer {g} g",
    "nutrition.photo.again": "Opnieuw",
    "nutrition.photo.meal": "Deze maaltijd",
    "nutrition.photo.estimateNote": "Een schatting van een foto is niet precies; je kunt het in de volgende stap aanpassen. Voor verpakt eten is de streepjescode nauwkeuriger.",
    "nutrition.impact.title": "Hoeveel van je dag deze maaltijd is",
    "nutrition.impact.kcalLine": "{kcal} kcal, {pct}% van je dag",
    "nutrition.impact.noKcal": "Calorieën onbekend",
    "nutrition.impact.overToday": "Met deze maaltijd ga je vandaag over je doel voor {list}. Neem wat minder, of eet de volgende maaltijd licht.",
    "nutrition.impact.overDay": "Met deze maaltijd gaat die dag over het doel voor {list}.",
    "nutrition.impact.leftToday": "Na deze maaltijd heb je vandaag nog {kcal} kcal over.",
    "nutrition.impact.leftDay": "Met deze maaltijd heeft die dag nog {kcal} kcal over.",
    "nutrition.impact.name.kcal": "Energie",
    "nutrition.impact.name.sugar": "suiker",
    "nutrition.impact.name.fat": "vet",
    "nutrition.impact.name.salt": "zout",
    "nutrition.impact.name.carbs": "koolhydraten",
    "nutrition.impact.name.protein": "eiwit",
    "nutrition.impact.limitLeft": "{daily} {unit} per dag, nog {n} {unit}",
    "nutrition.impact.overBy": "{n} {unit} te veel",
    "nutrition.impact.needLeft": "Vandaag nog {n} {unit} nodig",
    "nutrition.impact.needMet": "Genoeg voor vandaag",
    "nutrition.impact.unknown": "Onbekend",
    "nutrition.impact.basisGoal": "Op basis van je dagdoelen; zonder doel geldt de referentie-inname voor volwassenen van EU-verpakkingen. Licht: vandaag al gegeten. Donker: deze maaltijd.",
    "nutrition.impact.basisRi": "Op basis van de referentie-inname voor volwassenen op EU-verpakkingen: 2000 kcal, 70 g vet, 90 g suiker, 6 g zout. Licht: vandaag al gegeten. Donker: deze maaltijd. Stel je eigen doelen in bij Mijn doelen.",
    "nutrition.month.title": "Deze maand",
    "nutrition.month.prev": "Vorige maand",
    "nutrition.month.next": "Volgende maand",
    "nutrition.month.noWeight": "Nog geen gewicht ingevuld. Vul je gewicht van vandaag in als startpunt van deze maand!",
    "nutrition.month.startedOn": "Startpunt: {date}",
    "nutrition.month.logWeight": "Gewicht invullen",
    "nutrition.month.weightKg": "Gewicht (kg)",
    "nutrition.month.weightHint": "Weeg jezelf steeds op hetzelfde moment, bijvoorbeeld 's ochtends voor het ontbijt.",
    "nutrition.month.weightSaved": "Gewicht opgeslagen",
    "nutrition.body.title": "Mijn gewicht",
    "nutrition.body.kg": "kg",
    "nutrition.body.today": "Vandaag",
    "nutrition.body.lastOn": "Laatst gewogen: {date}",
    "nutrition.body.waistShort": "taille {cm} cm",
    "nutrition.body.none": "Nog geen gewicht ingevuld. Weeg jezelf elke ochtend om het effect van je eten te zien.",
    "nutrition.body.sinceMonth": "Verschil deze maand",
    "nutrition.body.logToday": "Gewicht van vandaag invullen",
    "nutrition.body.editToday": "Gewicht van vandaag wijzigen",
    "nutrition.body.bmi.under": "Ondergewicht",
    "nutrition.body.bmi.normal": "Gezond",
    "nutrition.body.bmi.over": "Overgewicht",
    "nutrition.body.bmi.obese": "Obesitas",
    "nutrition.body.standard": "Standaardgewicht",
    "nutrition.body.above": "{kg} kg erboven",
    "nutrition.body.below": "{kg} kg eronder",
    "nutrition.body.healthy": "Gezond bereik",
    "nutrition.body.askHeight": "Vul je lengte in om je BMI en standaardgewicht te zien.",
    "nutrition.body.setHeight": "Lengte invullen",
    "nutrition.body.heightShort": "Lengte {cm}",
    "nutrition.body.height": "Lengte (cm)",
    "nutrition.body.heightHint": "Eén keer — voor BMI en standaardgewicht",
    "nutrition.body.waist": "Taille (cm)",
    "nutrition.body.optional": "Optioneel",
    "nutrition.body.formula": "Standaardgewicht = lengte (cm) − 105. Het gezonde bereik is BMI 18,5–24,9.",
    "nutrition.month.days": "Dagen bijgehouden",
    "nutrition.month.avgKcal": "Energie per dag",
    "nutrition.month.avgSugar": "Suiker per dag",
    "nutrition.month.drinkSugar": "Suiker uit dranken",
    "nutrition.month.drinks": "{n} drankjes · {kcal} kcal",
    "nutrition.month.fasts": "Gevast volgens plan",
    "nutrition.month.longest": "Langste {h} u",
    "nutrition.month.sugarDays": "Dagen binnen suikerdoel",
    "nutrition.month.sugarMax": "≤ {g} g per dag",
    "nutrition.month.empty": "Deze maand nog niets bijgehouden. Vul je eerste maaltijd in en verzamel prestaties!",
    "nutrition.month.export": "Deze maand exporteren naar Excel",
    "nutrition.month.exportHint": "Vijf tabbladen: overzicht met grafieken, per dag, gewicht & lichaam, dranken en vasten.",
    "nutrition.ach.logged_days": "{days} dagen je eten bijgehouden",
    "nutrition.ach.logging_streak": "{days} dagen op rij, knap volgehouden!",
    "nutrition.ach.sugar_days": "{days} dagen binnen je suikerdoel",
    "nutrition.ach.fasts_done": "{count} keer gevast volgens plan",
    "nutrition.ach.longest_fast": "Langste vasten {hours} uur",
    "nutrition.ach.weight_lost": "{kg} kg afgevallen, goed gedaan!",
    "nutrition.ach.weight_steady": "Gewicht stabiel gehouden",
    "nutrition.badge.streak7": "7 dagen op rij",
    "nutrition.badge.logged20": "20 dagen bijgehouden",
    "nutrition.badge.sugar15": "Suikerkampioen",
    "nutrition.badge.fast10": "Vastenkenner",
    "nutrition.badge.fast18h": "18-uursuitdaging",
    "nutrition.badge.lost1kg": "1 kg lichter",
    "nutrition.meal.drink": "Dranken",
    "nutrition.scan.tipMedium": "Gemiddeld veel {list}; let op de portie.",
    "nutrition.scan.tipPortionSugar": "Deze portie bevat ongeveer {g} g suiker, {pct}% van de ideale dagelijkse grens voor vrije suikers van de WHO (25 g).",
    "nutrition.scan.tipNutriScore": "Nutri-Score {grade}: lage voedingskwaliteit. Neem het minder vaak, of kies een vergelijkbaar product met een betere score.",
    "nutrition.scan.button": "Scannen",
    "nutrition.scan.title": "Streepjescode scannen",
    "nutrition.scan.hint": "Houd de streepjescode op de verpakking in het kader. Hij wordt vanzelf gelezen.",
    "nutrition.scan.slow": "Lukt het niet? Houd de streepjescode recht, 15–20 cm van je telefoon, zonder schittering; draai een bolle fles zodat de code recht naar de camera wijst. Of maak hieronder een foto, of typ de cijfers onder de streepjescode.",
    "nutrition.scan.starting": "Camera openen…",
    "nutrition.scan.noCamera": "De camera kon niet worden geopend. Maak een foto van de streepjescode of typ de cijfers eronder.",
    "nutrition.scan.photo": "Foto van de streepjescode",
    "nutrition.scan.manual": "Of typ de streepjescode",
    "nutrition.scan.lookup": "Opzoeken",
    "nutrition.scan.looking": "Voedingswaarden opzoeken…",
    "nutrition.scan.notFound": "Dit product ({code}) staat nog niet in de database. Fotografeer het voedingswaardelabel en laat de AI het lezen.",
    "nutrition.scan.notFoundAction": "Foto van het label",
    "nutrition.scan.noCode": "Geen streepjescode gevonden op de foto. Kom dichterbij, stel scherp en probeer opnieuw.",
    "nutrition.scan.again": "Nog een scannen",
    "nutrition.scan.per100g": "Per 100 g",
    "nutrition.scan.per100ml": "Per 100 ml",
    "nutrition.scan.amount": "Hoeveel heb je gegeten ({unit})",
    "nutrition.scan.serving": "Eén portie: {label}",
    "nutrition.scan.forAmount": "{amount}{unit} bevat",
    "nutrition.scan.log": "Toevoegen aan mijn maaltijden",
    "nutrition.scan.source": "Voedingswaarden van Open Food Facts, een open database. Ze kunnen fouten bevatten; de verpakking is leidend.",
    "nutrition.scan.nutriScore": "Nutri-Score",
    "nutrition.scan.kcal": "Energie",
    "nutrition.scan.tipHigh": "Veel {list}. Af en toe prima; let op de portie en eet er groente bij.",
    "nutrition.scan.tipOk": "Niet veel vet, suiker of zout. Een goede keuze.",
    "nutrition.scan.sep": ", ",
    "nutrition.level.low": "Laag",
    "nutrition.level.medium": "Gem.",
    "nutrition.level.high": "Hoog",
    "nutrition.light.fat": "vet",
    "nutrition.light.saturatedFat": "verzadigd vet",
    "nutrition.light.sugar": "suiker",
    "nutrition.light.salt": "zout",
    "nutrition.fast.title": "Periodiek vasten",
    "nutrition.fast.setup": "Vasten instellen",
    "nutrition.fast.settings": "Instellingen vasten",
    "nutrition.fast.intro": "Kies een schema, bijvoorbeeld 16:8: eet elke dag binnen 8 uur en drink de andere 16 uur alleen water, thee of zwarte koffie.",
    "nutrition.fast.plan": "Schema",
    "nutrition.fast.planDesc": "{fast} u vasten · {eat} u eten",
    "nutrition.fast.eatStart": "Eten begint om",
    "nutrition.fast.window": "Eten {start}–{end}",
    "nutrition.fast.show": "Vasten tonen op de maaltijdenpagina",
    "nutrition.fast.saved": "Instellingen vasten opgeslagen",
    "nutrition.fast.status.fasting": "Aan het vasten",
    "nutrition.fast.status.reached": "Doel gehaald",
    "nutrition.fast.status.eating": "Eetvenster",
    "nutrition.fast.status.idle": "Nog niet aan het vasten",
    "nutrition.fast.elapsed": "{h} u {m} min aan het vasten",
    "nutrition.fast.remaining": "Nog {h} u {m} min",
    "nutrition.fast.closesIn": "Eetvenster sluit over {h} u {m} min",
    "nutrition.fast.opensIn": "Eetvenster opent over {h} u {m} min",
    "nutrition.fast.goal": "Doel {h} u",
    "nutrition.fast.start": "Begin met vasten",
    "nutrition.fast.startEarlier": "Ik ben eerder begonnen",
    "nutrition.fast.startTime": "Begintijd",
    "nutrition.fast.end": "Vasten stoppen",
    "nutrition.fast.endEarly": "Eerder stoppen",
    "nutrition.fast.editStart": "Begintijd wijzigen",
    "nutrition.fast.streak": "{n} dagen op rij",
    "nutrition.fast.history": "Recent gevast",
    "nutrition.fast.duration": "{h} u {m} min",
    "nutrition.fast.reachedShort": "Gehaald",
    "nutrition.fast.short": "Te kort",
    "nutrition.fast.delete": "Verwijderen",
    "nutrition.fast.ended": "Vasten gestopt na {h} u {m} min.",
    "nutrition.fast.endedReached": "Goed gedaan! Je hebt {h} u {m} min gevast.",
    "nutrition.fast.caution": "Vasten is niet geschikt tijdens zwangerschap of borstvoeding, bij diabetes (zeker met medicijnen), bij een eetstoornis in het verleden of voor kinderen. Heb je gezondheidsklachten, overleg dan eerst met je huisarts. Drink genoeg water en stop als je je niet goed voelt.",
    "nutrition.title": "Eten",
    "nutrition.answer.title": "Genoteerd: {name}",
    "nutrition.answer.thisFood": "Deze portie: {kcal} kcal, {sugar} g suiker.",
    "nutrition.answer.thisDrink": "Dit drankje: {kcal} kcal, {sugar} g suiker.",
    "nutrition.answer.breaksFast": "Er zitten calorieën in, dus je vasten wordt onderbroken (al {h} u {m} min). Het vasten nu beëindigen?",
    "nutrition.answer.keepsFast": "Bijna geen calorieën: je vasten gaat gewoon door (al {h} u {m} min).",
    "nutrition.answer.outsideWindow": "Dit valt buiten je eetvenster ({from}–{to}). Af en toe is prima; vaak maakt het vasten minder effectief.",
    "nutrition.answer.today": "Vandaag tot nu toe",
    "nutrition.answer.thatDay": "Die dag",
    "nutrition.answer.left": "Nog {n} {unit}",
    "nutrition.answer.over": "{n} {unit} te veel",
    "nutrition.answer.burned": "Je hebt vandaag {kcal} kcal verbrand met bewegen; dat telt mee.",
    "nutrition.answer.ok": "Oké",
    "nutrition.answer.keepFast": "Doorgaan met vasten",
    "nutrition.answer.endFast": "Vasten beëindigen",
    "nutrition.answer.fastEnded": "Vasten beëindigd; eettijd begint",
    "nutrition.form.ateOut": "Uit eten of afhaal? Noteer wat het kostte (komt in het huishoudboekje)",
    "nutrition.form.cost": "Wat het kostte",
    "nutrition.form.place": "Waar (optioneel)",
    "nutrition.form.placePh": "bijv. Pizzeria Napoli",
    "nutrition.answer.booked": "Ook in het huishoudboekje: {amount} (uit eten)",
    "nutrition.hub.snap": "Calorieëncalculator",
    "nutrition.hub.snapSub": "3 keer per dag: fotografeer je maaltijd, AI schat calorieën en suiker",
    "nutrition.hub.snapLeft": "3 per dag: fotografeer je maaltijden voor calorieën en suiker · nog {n} vandaag",
    "nutrition.snap.title": "Calorieëncalculator",
    "nutrition.snap.intro": "3 keer per dag: fotografeer je drie maaltijden (ontbijt, lunch, avondeten) en de AI schat de calorieën, suiker en zout.",
    "nutrition.snap.liveScan": "Barcode direct scannen",
    "nutrition.snap.free": "Voor verpakt eten: „Verpakt eten fotograferen” — etiket of barcode, gratis, telt niet mee voor de 3.",
    "nutrition.snap.looking": "Even kijken wat het is…",
    "nutrition.snap.lookingPct": "Lezen… {pct}%",
    "nutrition.snap.notTable": "Geen barcode of voedingswaardetabel op deze foto. Is het een maaltijd?",
    "nutrition.snap.meal": "Een maaltijd: schat met de AI",
    "nutrition.snap.mealLeft": "Nog {n} schattingen vandaag",
    "nutrition.snap.mealNone": "Vandaag geen schattingen meer; vul het zelf in",
    "nutrition.snap.mealNoneTrial": "In de proefperiode 1 schatting per dag, vandaag gebruikt; vul het zelf in",
    "nutrition.snap.label": "Het is een tabel: laat de AI hem lezen",
    "nutrition.snap.labelLeft": "Nog {n} keer leeshulp deze maand",
    "nutrition.snap.labelNone": "Geen leeshulp meer deze maand",
    "nutrition.snap.manual": "Zelf invullen (foto bewaren)",
    "nutrition.snap.again": "Nieuwe foto",
    "nutrition.form.readLabel": "Voedingswaardetabel van de foto lezen (eerst gratis op de telefoon)",
    "nutrition.snap.aiOff": "AI is niet beschikbaar; vul het zelf in",
    "nutrition.snap.aiPaused": "AI is deze maand gepauzeerd (terug op de 1e); vul het zelf in",
    "nutrition.saved": "Genoteerd",
    "nutrition.footer": "De waarden zijn een richtlijn en vervangen geen advies van een arts of diëtist.",

    "nutrition.n.kcal": "Energie",
    "nutrition.n.protein": "Eiwit",
    "nutrition.n.fat": "Vet",
    "nutrition.n.carbs": "Koolhydraten",
    "nutrition.n.sugar": "Suikers",
    "nutrition.n.freeSugar": "Vrije suikers",
    "nutrition.n.salt": "Zout",
    "nutrition.n.potassium": "Kalium",
    "nutrition.unit.kcal": "kcal",
    "nutrition.unit.g": "g",
    "nutrition.unit.mg": "mg",

    "nutrition.meal.breakfast": "Ontbijt",
    "nutrition.meal.lunch": "Lunch",
    "nutrition.meal.dinner": "Avondeten",
    "nutrition.meal.snack": "Tussendoor",
    "nutrition.source.label": "Etiket",
    "nutrition.source.recipe": "Berekend",
    "nutrition.source.estimate": "Schatting",
    "nutrition.source.manual": "Handmatig",
    "nutrition.basis.portion": "Per portie",
    "nutrition.basis.100g": "Per 100 g",
    "nutrition.basis.100ml": "Per 100 ml",

    "nutrition.hero.title": "Wat zit er in deze maaltijd?",
    "nutrition.hero.titleOn": "Wat heb je op {date} gegeten?",
    "nutrition.hero.sub": "Maak een foto of scan, en zie meteen hoeveel van je dag het is.",
    "nutrition.hero.count": "{n} items · {kcal} kcal",
    "nutrition.hero.log": "Maaltijd noteren",

    "nutrition.date.nav": "Kies een dag",
    "nutrition.date.prev": "Vorige dag",
    "nutrition.date.next": "Volgende dag",
    "nutrition.date.toToday": "Vandaag",
    "nutrition.date.week": "Calorieën van de afgelopen 7 dagen",
    "nutrition.date.nothing": "niets genoteerd",

    "nutrition.again.title": "Nog een keer",

    "nutrition.summary.title": "Dagtotaal",
    "nutrition.summary.all": "Alle voedingsstoffen",
    "nutrition.summary.fewer": "Minder tonen",
    "nutrition.summary.unknown": "Nog geen gegevens",
    "nutrition.summary.partial": "Gedeeltelijk totaal",
    "nutrition.summary.partialCount": "Ontbreekt bij {n} items",
    "nutrition.summary.partialNote": "≈ betekent dat niet elk item deze waarde heeft, dus het echte totaal kan hoger zijn.",
    "nutrition.status.within": "Goed bezig",
    "nutrition.status.above": "Boven max",
    "nutrition.status.below": "Onder min",
    "nutrition.target.range": "doel {min}–{max} {unit}",
    "nutrition.target.max": "max {max} {unit}",
    "nutrition.target.min": "minstens {min} {unit}",
    "nutrition.target.none": "Geen doel ingesteld",

    "nutrition.meals.title": "Mijn maaltijden",
    "nutrition.meals.addTo": "Toevoegen aan {meal}",
    "nutrition.meals.empty": "{meal} toevoegen",

    "nutrition.window.title": "Eettijden",
    "nutrition.window.first": "Eerste hap",
    "nutrition.window.last": "Laatste hap",
    "nutrition.window.span": "{h} u {m} min",
    "nutrition.window.note": "Dit laat alleen zien wanneer je at; het is geen medisch advies. Overleg met je huisarts voordat je gaat vasten of je eettijden verandert.",

    "nutrition.tips.label": "Tips",
    "nutrition.tip.sugar.1.title": "De zoetekauw is vandaag ruim bediend",
    "nutrition.tip.sugar.1.body": "Straks dorst? Water of thee zonder suiker doet wonderen.",
    "nutrition.tip.sugar.2.title": "De suikerpot is leeg voor vandaag",
    "nutrition.tip.sugar.2.body": "Trek in iets? Een handje noten of een appel smaakt ook prima.",
    "nutrition.tip.sugar.3.title": "Het toetje heeft vandaag al ingeklokt",
    "nutrition.tip.sugar.3.body": "Morgen weer welkom. Groente en water nemen de rest van de dag over.",
    "nutrition.tip.kcal.1.title": "De tank is vol voor vandaag",
    "nutrition.tip.kcal.1.body": "Nog trek? Kies iets lichts, zoals soep of wat groente.",
    "nutrition.tip.kcal.2.title": "Energiedoel bereikt",
    "nutrition.tip.kcal.2.body": "Een ommetje na het eten voelt goed en helpt de spijsvertering.",
    "nutrition.tip.kcal.3.title": "Dat was een goed gevulde dag",
    "nutrition.tip.kcal.3.body": "Af en toe wat meer is prima: morgen is een nieuwe bladzijde.",
    "nutrition.tip.carbs.1.title": "De koolhydraten hadden een topdag",
    "nutrition.tip.carbs.1.body": "Volgende maaltijd wat meer groente en eiwit, en wat minder brood of pasta?",
    "nutrition.tip.carbs.2.title": "Koolhydratenquotum bereikt",
    "nutrition.tip.carbs.2.body": "Volkoren varianten houden je langer verzadigd.",
    "nutrition.tip.carbs.3.title": "Pasta, brood en rijst: allemaal aanwezig",
    "nutrition.tip.carbs.3.body": "Als tussendoortje is yoghurt of een handje noten een leuke afwisseling.",

    "nutrition.form.newTitle": "Maaltijd noteren",
    "nutrition.form.editTitle": "Item bewerken",
    "nutrition.form.repeatTitle": "Nog een keer",
    "nutrition.form.photo": "Foto (optioneel)",
    "nutrition.form.aiMode": "Wat staat er op de foto",
    "nutrition.form.aiLabel": "Voedingsetiket",
    "nutrition.form.aiMeal": "Bord met eten",
    "nutrition.form.aiRead": "Foto lezen met AI",
    "nutrition.form.aiReading": "Bezig met lezen…",
    "nutrition.form.aiDoneLabel": "Ingevuld vanaf het etiket. Controleer het even voordat je opslaat.",
    "nutrition.form.aiDoneEstimate": "Ingevuld met schattingen. Schattingen op basis van een foto zijn grof, dus controleer ze even.",
    "nutrition.form.name": "Wat heb je gegeten?",
    "nutrition.form.namePlaceholder": "bijv. Magere yoghurt",
    "nutrition.form.nameRequired": "Vul in wat je hebt gegeten.",
    "nutrition.form.nameTooLong": "De naam mag maximaal {n} tekens zijn.",
    "nutrition.form.meal": "Maaltijd",
    "nutrition.form.date": "Datum",
    "nutrition.form.dateInvalid": "Kies een geldige datum.",
    "nutrition.form.dateFuture": "De datum kan niet na vandaag liggen.",
    "nutrition.form.time": "Tijd",
    "nutrition.form.timeInvalid": "Gebruik uren en minuten, bijv. 08:15.",
    "nutrition.form.basis": "Deze getallen gelden voor",
    "nutrition.form.grams": "Hoeveel heb je gegeten ({unit})",
    "nutrition.form.gramsHint": "Bij opslaan rekenen we de waarden om naar deze hoeveelheid.",
    "nutrition.form.gramsInvalid": "Vul een hoeveelheid tussen 0,1 en 10000 in.",
    "nutrition.form.valuesPortion": "Voedingswaarde van deze portie",
    "nutrition.form.valuesPer100": "Voedingswaarde per 100 {unit}",
    "nutrition.form.freeSugarHint": "Toegevoegde suiker, honing, siroop en vruchtensap",
    "nutrition.form.blankUnknown": "Laat een veld leeg als je het niet weet: leeg betekent onbekend, niet nul.",
    "nutrition.form.valueInvalid": "Vul een getal van 0 tot {max} in.",
    "nutrition.form.freeSugarTooHigh": "Vrije suikers kunnen niet meer zijn dan het totaal aan suikers.",
    "nutrition.form.sugarTooHigh": "Suikers kunnen niet meer zijn dan koolhydraten (suiker hoort bij de koolhydraten).",
    "nutrition.form.scaledTooHigh": "Met deze hoeveelheid worden de waarden te hoog. Controleer het even.",
    "nutrition.form.trash": "Naar prullenbak",
    "nutrition.form.repeat": "Vandaag nog een keer noteren",

    "nutrition.goals.title": "Mijn doelen",
    "nutrition.goals.goal": "Wat ik het liefst wil",
    "nutrition.goal.balanced": "Gevarieerd",
    "nutrition.goal.weight": "Gewicht",
    "nutrition.goal.sugar": "Minder suiker",
    "nutrition.goal.salt": "Minder zout",
    "nutrition.goal.balanced.hint": "Alle richtwaarden uit het WHO-advies voor gezond eten.",
    "nutrition.goal.weight.hint": "Blijf met je calorieën onder de grens die je instelt.",
    "nutrition.goal.sugar.hint": "Let vooral op suikers en vrije suikers; geen bereik voor koolhydraten.",
    "nutrition.goal.salt.hint": "Let vooral op zout: niet meer dan 5 g per dag.",
    "nutrition.goals.helper": "Richtwaarden invullen",
    "nutrition.goals.helperIntro": "Met je dagelijkse energiebehoefte en je gewicht berekenen we de WHO-richtwaarden voor volwassenen. Je kunt ze daarna nog per stuk aanpassen.",
    "nutrition.goals.energy": "Energie per dag",
    "nutrition.goals.energyHint": "1000–5000 kcal",
    "nutrition.goals.energyInvalid": "Vul een energiebehoefte tussen 1000 en 5000 kcal in.",
    "nutrition.goals.weight": "Lichaamsgewicht",
    "nutrition.goals.weightHint": "30–300 kg",
    "nutrition.goals.weightInvalid": "Vul een gewicht tussen 30 en 300 kg in.",
    "nutrition.goals.adult": "Ik ben volwassen (deze waarden gelden alleen voor volwassenen)",
    "nutrition.goals.adultRequired": "Bevestig eerst dat je volwassen bent.",
    "nutrition.goals.potassium": "Mijn nieren zijn gezond (voegt een dagelijks minimum voor kalium toe; niet aanvinken bij nierziekte, vraag je arts)",
    "nutrition.goals.fill": "Waarden invullen",
    "nutrition.goals.filled": "Hieronder ingevuld. Kijk ze even na en sla op.",
    "nutrition.goals.perNutrient": "Per voedingsstof",
    "nutrition.goals.perNutrientHint": "Laat leeg voor geen grens.",
    "nutrition.goals.min": "Min",
    "nutrition.goals.max": "Max",
    "nutrition.goals.noMin": "Alleen max",
    "nutrition.goals.minAboveMax": "Het minimum kan niet hoger zijn dan het maximum.",
    "nutrition.goals.valueInvalid": "Vul een getal van 0 tot 100000 in.",
    "nutrition.goals.fixErrors": "Een paar waarden kloppen nog niet; zie de meldingen hierboven.",
    "nutrition.goals.disclaimer": "Dit zijn algemene richtlijnen, geen medisch advies. Heb je een aandoening, ben je zwanger of volg je een dieet, ga dan uit van het advies van je arts.",
    "nutrition.goals.saved": "Doelen opgeslagen",
    "nutrition.goals.invite": "Je ziet nu de WHO-standaard: maximaal 5 g zout per dag; voor vrije suikers zegt de WHO maximaal 50 g, liefst niet meer dan 25 g. Stel je eigen doelen in voor een duidelijker beeld.",
    "nutrition.goals.set": "Mijn doelen instellen",

    "nutrition.trash.open": "Prullenbak ({n})",
    "nutrition.trash.title": "Verwijderde items",
    "nutrition.trash.intro": "Zet een item terug of verwijder het definitief.",
    "nutrition.trash.empty": "De prullenbak is leeg",
    "nutrition.trash.confirmTitle": "Definitief verwijderen?",
    "nutrition.trash.confirmBody": "‘{name}’ wordt definitief verwijderd. Dit kan niet ongedaan worden gemaakt.",

    "nutrition.guide.title": "Richtlijnen & bronnen",
    "nutrition.guide.intro": "De richtwaarden volgen het advies van de Wereldgezondheidsorganisatie (WHO) voor gezond eten bij volwassenen:",
    "nutrition.guide.salt": "Zout: minder dan 5 g per dag (ongeveer een afgestreken theelepel).",
    "nutrition.guide.sugar": "Vrije suikers: minder dan 10% van de energie, liefst onder 5%.",
    "nutrition.guide.fat": "Vet: minder dan 30% van de energie.",
    "nutrition.guide.carbs": "Koolhydraten: ongeveer 45–75% van de energie.",
    "nutrition.guide.potassium": "Kalium: minstens 3510 mg per dag (tenzij je nierproblemen hebt).",
    "nutrition.guide.whoDiet": "WHO: factsheet gezond eten (Engels)",
    "nutrition.guide.whoSugar": "WHO: richtlijn suikerinname voor volwassenen en kinderen (Engels)",
    "nutrition.guide.estimates": "Waarden uit foto's zijn schattingen van de AI en kunnen afwijken. Controleer ook wat er van een etiket is gelezen.",
    "nutrition.guide.notMedical": "Dit is geen medisch advies. Heb je vragen over je gezondheid, stel ze dan aan een arts of diëtist.",
    "nutrition.guide.privacy": "Alleen jij kunt je eetdagboek zien.",
    "nutrition.hero.logDrink": "Drankje",
    "nutrition.guide.short": "Gids",
    "nutrition.fast.off": "Vasten staat uit",
    "nutrition.fast.offOpen": "Instellingen openen",
    "nutrition.fast.settingsShort": "Instellingen",
    "nutrition.fast.deleteTitle": "Deze vastenperiode verwijderen?",
    "nutrition.fast.deleteBody": "Dit item wordt definitief verwijderd. Dit kan niet ongedaan worden gemaakt.",
    "nutrition.form.more": "Meer voedingswaarden / datum en tijd",
    "nutrition.form.moreHint": "Eiwit, vet, koolhydraten, zout en meer, plus datum, tijd en hoeveelheid",
    "nutrition.form.reviewHint": "Controleer de naam en de maaltijd, pas de getallen zo nodig aan en tik op ‘Opslaan’.",
    "nutrition.form.labelIntro": "Streepjescode {code} is niet gevonden. Fotografeer het voedingswaardelabel op de verpakking; de AI leest de getallen en jij controleert ze.",
    "nutrition.form.labelIntroNoAi": "Streepjescode {code} is niet gevonden. Neem de getallen over van het voedingswaardelabel op de verpakking.",
    "nutrition.scan.badCode": "Het aantal cijfers of het controlecijfer klopt niet. Controleer de streepjescode.",
    "nutrition.photo.noAi": "Een schatting van een foto kan nu niet.",
    "nutrition.photo.noAiPlan": "Je account heeft op dit moment geen AI-scans.",
    "nutrition.photo.noAiAlt": "Je kunt het zelf invullen, of bij verpakt eten de streepjescode scannen.",
    "nutrition.photo.manual": "Zelf invullen",
    "nutrition.month.exportEmpty": "Deze maand is er nog niets om te exporteren",
    "nutrition.trash.row": "Prullenbak",
    "nutrition.goals.estimate": "Weet je het niet? Schat het op gewicht",
    "nutrition.goals.estimateNeedWeight": "Vul eerst je gewicht in voor een schatting.",
    "nutrition.goals.estimateResult": "Grove schatting: gewicht × 30 ≈ {kcal} kcal. Alleen een richtgetal: wie veel beweegt heeft meer nodig, wie wil afvallen wat minder.",
    "nutrition.goals.estimateUse": "{kcal} kcal gebruiken",
    "nutrition.goals.weightFromLog": "Ingevuld met je laatst genoteerde gewicht",
    "nutrition.goals.advanced": "Per voedingsstof aanpassen (gevorderd)",
  },
} satisfies Dict;
